/// <reference path="./typings/index.d.ts" />

var pageController = undefined;
var isSb = undefined;
var isTerminal = undefined;
var goBackFlag = false;
var UA = undefined;
// tds2認証HOST
var TDS2_APPROVEURL_HOST = '';
// tds認証URL
var TDS2_APPROVEURL_URL = 'redirectTds2.html';

//tds認証LBK_ST
var TDS2_APPROVE_ST = '';

//tds認証LB_PR1
var TDS2_APPROVE_PR1 = '';

//tds認証LB_PR2
var TDS2_APPROVE_PR2 = '';
var TDS2_ORDER_ID = '';

//tds認証JSESSIONID
var TDS2_APPROVE_JSESSION_ID = '';
var sbpsWindow = undefined;
// 流入パラメータ
var params = undefined;

// token
var token = undefined;

// 予約情報
var reservationInfo = undefined;

// 新予約画面URL
var OLS_APPLY_URL = "";
// 住所情報リスト
var addressInfo = undefined;
// テスト公開日時
var openDate = new Date().getTime();
// 業務日付
var systemDate = new Date().getTime();
// 金額総額表示制御フラグ
var totalPriceDispCtlFlg = false;
// あんしん保証パック選択状態フラグ
var safePackCheckedFlg = false;
// あんしん保証パック選択状態の機種
var safePackItemCd = '';
// 前次の暗証番号表示フラグ
var lastHlrPasswordShowFlg = undefined;
// 前次の国籍表示フラグ
var lastNationalShowFlg = undefined;
//前次の職業表示フラグ
var lastJobOnlyShowFlg = undefined;
//　本次の暗証番号表示フラグ
var thisHlrPasswordShowFlg = false;
// 本次の国籍表示フラグ
var thisNationalShowFlg = false;
//本次の職業表示フラグ
var thisJobOnlyShowFlg = false;
//前次の暗証番号表示フラグ
var lastSbHlrPasswordShowFlg = undefined;
//本次の暗証番号表示フラグ
var thisSbHlrPasswordShowFlg = false;
// 本人確認書類リスト
var isAlreadyDrownIdDocumentListlength = 0;
var json = undefined;

var savePosition = void 0;
var J_MODAL = new jModal('.j_modal', {
    modalSpeed: 400,
    bgOpacity: 0.6,
    closeBtn: "",
    addClass: "mg10",
    width: "864px",
    closeEnd: function () {
        Utils.scrollBody(true, savePosition);
        if (this.ModalCloseFun) {
            this.ModalCloseFun();
            delete this.ModalCloseFun;
        }
    }
});
// #topでリフレッシュでも動作できるため
location.replace('#init');

var isHashChangeHandling = false;
// hashchangeのイベントは先に設定
$(function () {

    // CasisクッキークリアAPIを呼び
    var logout = getEnviromentInfo(logoutList);
    Utils.loadScriptStatus("logout", logout);

    // hashchangeのイベントで画面遷移
    $(window).bind('hashchange', function () {

        // loadingを表示する
        showLoading();
        isHashChangeHandling = true;

        // 本当に行っていい画面なのかチェック
        if (!$('body > div' + location.hash + ', body > div#container > main' + location.hash).hasClass('history')) return;
        // 一旦、全部消す
        $('body > div, body > div#container > main').removeClass('current');
        // 今、表示したい画面のみ表示する
        $('body > div' + location.hash + ', body > div#container > main' + location.hash).addClass('current');
        // 表示した画面より後のパンくずを消す
        $('body > div' + location.hash + '~div' + ', body > div#container > main' + location.hash).removeClass('history');
        if (location.hash === '#deviceSelect') {
            if (!initDoneFlag) {
                pageController = new PageController();
                pageController.init();
            } else {
                // ケースリフレッシュ
                $("#sliderBox").slick("refresh");
            }
        }
        $('body').toggleClass('nonmember', !isSb);
        Utils.titleChange(location.hash);
        if (goBackFlag) {
            $('body,html').animate({
                scrollTop: $("#footer_logo").offset().top
            }, 0);
            goBackFlag = false;
        }

        isHashChangeHandling = false;
        if (location.hash != '#init' && ajaxCallNum == 0) {
            // loadingを非表示する
            hideLoading();
        }

        // IE専用
        window.history.pushState('forward', null, document.URL);
        window.history.forward(1);

        // Flow表示位置の設定
        Utils.drawSpFlow();
    });

    // すべての画面でブラザーの戻るボタンを押しても戻れないように
    if (window.history && window.history.pushState) {
        $(window).on('popstate', function () {
            window.history.pushState('forward', null, document.URL);
            window.history.forward(1);
        });
    }
});

// jQueryのお作法
// DOMの形成前にjQueryが動くのを防ぐ
var OLS = undefined;
$(function () {
    // 制御用のオブジェクトを用意
    OLS = {
        //top画面において、クリックしたボタンを青くするアニメーション
        contractStatusChange: function (thisItem) {
            //チェックをつけた label があれば、それの checked class を remove する
            $('#top #applType label' + '.checked').removeClass('checked');

            //チェックした label に checked クラスを追加する。
            $(thisItem).parent('div').parent('label').addClass('checked');
            $('#top #link a.disabled').removeClass('disabled');
        },

        // 渡した機種選択用パラメータパタンにをチェックする
        isDeviceSelectParams: function () {
            // applTypeとitemTypeとgoodsCd１つ必要チェック
            if (isEmpty(params.applType) &&
                isEmpty(params.goodsCd) &&
                isEmpty(params.itemType)) {
                return false;
            }
            // 通常申込、かつ、goodsCdが未設定、機種選択用パラメータがいくつか存在する場合はチェックを行う
            if (isEmpty(params.goodsCd) &&
                isEmpty(params.applType) &&
                !(isEmpty(params.itemType) &&
                    isEmpty(params.iT_Sub1) &&
                    isEmpty(params.iT_Sub2) &&
                    isEmpty(params.iT_Sub3))) {

                if (!isEmpty(params.itemType)) {
                    if (!isEmpty(params.iT_Sub1)) {
                        if (!isEmpty(params.iT_Sub2)) {
                            return checkAgencyShopCd(params.agencyShopCd);
                        } else {
                            if (!isEmpty(params.iT_Sub3)) {
                                return false;
                            } else {
                                return checkAgencyShopCd(params.agencyShopCd);
                            }
                        }
                    } else {
                        if (!isEmpty(params.iT_Sub2)) {
                            return false;
                        } else {
                            if (!isEmpty(params.iT_Sub3)) {
                                return false;
                            } else {
                                return checkAgencyShopCd(params.agencyShopCd);
                            }
                        }
                    }
                } else {
                    // error
                    return false;
                }
            } else {
                return checkAgencyShopCd(params.agencyShopCd);
            }
        },

        // 渡した機種選択用パラメータにをチェックする
        checkDeviceSelectParams: function () {
            if (!OLS.isDeviceSelectParams()) {
                // パラメータをチェックして、NGの場合、エラー画面に遷移する
                location.replace(ERROR_URL + '?errorMessage=' +
                    encodeURIComponent(getMessage("message_error_access", "errPage")));
            }
        },

        // sessionStorage → localStorage
        setSessionStorage: function (key, value) {
            if (!window.localStorage) return;
            try {
                localStorage.setItem(key, value);
            } catch (err) {
                return false;
            }
        },

        // sessionStorage → localStorage
        getSessionStorage: function (key) {
            if (!window.localStorage) return "";
            try {
                return localStorage.getItem(key);
            } catch (err) {
                return false;
            }
        },

        // localStorage情報の個別削除
        singleDeleteStorage: function (key){

            // keyに紐づく値を削除
            try{
                localStorage.removeItem(key);
            } catch (e) {
                return false;
            }

            return true;
        },

        // 初期化localStorage
        clearAllStorage: function () {
            var cookieKey = ["loginType", "contractorReserveNo", "inflowSiteCd", "isNewAw", "rediretToOrsAd", "prevPayAllTotal"];
            for (var index in cookieKey) {
                OLS.singleDeleteStorage(cookieKey[index]);
            }
        },

        // 広告パラメータとパラメータに値が設定されている場合、SessionStorageを存入する
        setAdParams: function () {
            var existParams = [];
            for (var key in AD_PARAMS) {
                if(params[AD_PARAMS[key]]) {
                    existParams.push(AD_PARAMS[key] + "=" + params[AD_PARAMS[key]]);
                }
            }
            if (existParams.length > 0) {
                OLS.setSessionStorage("rediretToOrsAd", "&" + existParams.join("&"));
            } else {
                OLS.setSessionStorage("rediretToOrsAd", "");
            }
        },

        // 広告パラメータを表示する
        adRestore: function(){
            window.history.replaceState("","", location.pathname + location.search + OLS.getSessionStorage("rediretToOrsAd"));
        },

        // init APIを呼出す
        init: function () {
            // 認証APIから戻る場合、SB契約者と認め
            if (!isEmpty(h.status) && h.status === 'ok') {

                // もう一回init apiを呼び出す。
                $.ajax({
                    timeout: 1000 * 30,
                    async: false,
                    cache: false,
                    type: 'GET',
                    dataType: 'json',
                    url: '/aw/api/v1/init',
                    contentType: 'application/json',
                    data: {},
                    success: function (data) {
                        // 正常の場合
                        params = {};
                        params.token = data.token;
                        params.itemType = data.item_type;
                        params.iT_Sub1 = data.it_sub1;
                        params.iT_Sub2 = data.it_sub2;
                        params.iT_Sub3 = data.it_sub3;
                        params.goodsCd = data.goods_code;
                        params.fixCtrl = data.fix_ctrl;
                        params.agncyId = data.agency_id;
                        params.applType = data.appl_type;
                        params.sb = data.sb;
                        params.agencyShopCd = data.agency_shop_cd;
                        params.modelInfo = data.model_info;
                        // 流入サイト判別コードを設定する
                        params.inflowSiteCd = OLS.getSessionStorage("inflowSiteCd");
                        openDate = parseInt(data.open_date);
                        systemDate  = parseInt(data.system_date);
                        token = params.token;
                        isSb = true;
                        totalPriceDispCtlFlg = data.total_price_disp_ctl_flg;
                        var agency_logo_image = data.agency_logo_image;
                        var agency_logo_image_smart_phone = data.agency_logo_image_smart_phone;
                        // 代理店ロゴを表示させる
                        OLS.displayShopLogo(agency_logo_image);

                        OLS.checkDeviceSelectParams();

                        // 申込完了までURLに広告パラメータが引き継がれる
                        OLS.adRestore();

                        // 契約者情報を取得する
                        Login.getUserInfo();

                        // ログイン後、ログイン前の画面選択状態をセットする
                        Login.setPageStatus();

                        // 金額総額文言表示制御
                        totalPriceTxtDisplayControl();

                        // 予約番号セット
                        if (!isEmpty(OLS.getSessionStorage("contractorReserveNo"))) {
                            $("#contractorReserveNo").val(OLS.getSessionStorage("contractorReserveNo"));
                        }
                    }
                });

            } else if (!isEmpty(h.status) && h.status !== 'ok') {
                // errorを戻る場合
                location.replace(ERROR_URL + '?errorMessage=' +
                    encodeURIComponent(getMessage("message_error_casis", "errPage")));
            } else {
                // 初めて
                params = h;
                // Google Pixel Watch購入、iT_sub指定無効
                if (!isEmpty(params.itemType) && params.itemType.indexOf('g') > -1) {
                    params.iT_Sub1 = "";
                    params.iT_Sub2 = "";
                    params.iT_Sub3 = "";
                }
                // localStorage情報初期化
                OLS.clearAllStorage();
                OLS.checkDeviceSelectParams();
                OLS.setAdParams();
                // SessionStorageに流入サイト判別コードを設定する
                OLS.setSessionStorage("inflowSiteCd",h.inflowSiteCd);
                // 新AWフラグ設定
                OLS.setSessionStorage("isNewAw", Utils.getUrlParameter()["seriesDiv"] == "aw");
                // Google Pixel Watchフラグ設定
                OLS.setSessionStorage("isWd", Utils.getUrlParameter()["seriesDiv"] == "wd");
                // 予約情報を初期化
                OLS.singleDeleteStorage("reservationInfo");

                // 初めてinit apiを呼び出す
                $.ajax({
                    timeout: 1000 * 30,
                    async: false,
                    cache: false,
                    type: 'GET',
                    dataType: 'json',
                    url: '/aw/api/v1/init',
                    contentType: 'application/json',
                    data: {
                        itemType: isEmpty(params.itemType) ? "" : params.itemType,
                        iT_Sub1: isEmpty(params.iT_Sub1) ? "" : params.iT_Sub1,
                        iT_Sub2: isEmpty(params.iT_Sub2) ? "" : params.iT_Sub2,
                        iT_Sub3: isEmpty(params.iT_Sub3) ? "" : params.iT_Sub3,
                        goodsCd: isEmpty(params.goodsCd) ? "" : params.goodsCd,
                        fixCtrl: isEmpty(params.fixCtrl) ? "" : params.fixCtrl,
                        agencyId: isEmpty(params.agncyId) ? "" : params.agncyId,
                        applType: isEmpty(params.applType) ? "" : params.applType,
                        sb: isEmpty(params.sb) ? "" : params.sb,
                        agencyShopCd: isEmpty(params.agencyShopCd) ? "" : params.agencyShopCd,
                        dmsn: isEmpty(params.dmsn) ? "" : params.dmsn,
                        seriesDiv: isEmpty(params.seriesDiv) ? "" : params.seriesDiv
                    },
                    success: function (data) {
                        // 正常の場合
                        token = data.token;
                        params.modelInfo = data.model_info;
                        // 表示機種区分 新aw/gw:1 旧aw:0 全部:3
                        params.displayModelKbn = data.display_model_kbn;
                        // 流入サイト判別コードを設定する
                        params.inflowSiteCd = OLS.getSessionStorage("inflowSiteCd");
                        // テスト公開日時
                        openDate = parseInt(data.open_date);
                        // 業務日付
                        systemDate  = parseInt(data.system_date);
                        // 代理店ロゴ
                        var agency_logo_image = data.agency_logo_image;
                        var agency_logo_image_smart_phone = data.agency_logo_image_smart_phone;
                        totalPriceDispCtlFlg = data.total_price_disp_ctl_flg;
                        // 代理店ロゴを表示させる
                        OLS.displayShopLogo(agency_logo_image);

                        // 本申し込み判定
                        if (!isEmpty(h.applType) && h.applType == 'D') {
                            // 予約本申し込み
                            // SB契約者判定
                            if (!isEmpty(h.sb) && (h.sb == 'Y' || h.sb == 'M')) {
                                // 認証誘い画面を表示
                                isSb = true;
                                OLS.proceed('login');
                                if (h.seriesDiv == "aw" || h.seriesDiv == "wd") {
                                    // ご予約番号の設定
                                    if (!isEmpty(h.reserveNo)) {
                                        // 予約番号チェック
                                        $("#contractorReserveNo").val(decodeURIComponent(h.reserveNo)).change();
                                        if (!$("#go-to-mySoftbank-login").hasClass("disabled")) {
                                            if (h.sb == 'Y') {
                                                Login.jumpToMsnLogin();
                                            } else {
                                                Login.jumpToDeviceLogin();
                                            }
                                        }
                                    } else {
                                        $("#contractorReserveNo").change();
                                    }
                                } else {
                                    Login.jumpToMsnLogin();
                                }
                            } else if (!isEmpty(h.sb) && h.sb == 'N') {
                                // 本申込
                                isSb = false;
                                OLS.proceed('reserveLogin');
                                // ご予約番号の設定
                                if (!isEmpty(h.reserveNo)) {
                                    $("#reserveNo").val(decodeURIComponent(h.reserveNo)).change();
                                }
                            } else {
                                // 以外の場合
                                // パラメータをチェックして、NGの場合、エラー画面に遷移する
                                location.replace(ERROR_URL + '?errorMessage=' +
                                    encodeURIComponent(getMessage("message_error_access", "errPage")));
                            }
                        } else if (typeof h.applType == "undefined") {
                            // URLにapplTypeが未設定場合
                            // 最初の画面
                            if (!ComingSoonControl(openDate)){
                                OLS.proceed('top');
                            }
                        } else {
                            // 以外の場合
                            // パラメータをチェックして、NGの場合、エラー画面に遷移する
                            location.replace(ERROR_URL + '?errorMessage=' +
                                encodeURIComponent(getMessage("message_error_access", "errPage")));
                        }
                        // 金額総額文言表示制御
                        totalPriceTxtDisplayControl();
                    }
                });
            }
        },

        // 予約情報を取得
        getSbReserveInfo: function () {
            if (!isEmpty(OLS.getSessionStorage("reservationInfo"))) {
                OLS.setReserveInfo(JSON.parse(OLS.getSessionStorage("reservationInfo")));
            } else {
                $.ajax({
                    timeout: 1000 * 30,
                    async: false,
                    cache: false,
                    type: 'GET',
                    dataType: 'json',
                    url: '/aw/api/v1/reservation/sb',
                    contentType: 'application/json',
                    data:"reserveNo=" + OLS.getSessionStorage("contractorReserveNo"),
                    success: function (data) {
                        // 予約データを保存する
                        OLS.setSessionStorage("reservationInfo", JSON.stringify(data));
                        // 予約情報を設定
                        OLS.setReserveInfo(data);
                    },
                    beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                        // 業務エラーが発生した場合、ポップアップ表示する前に、前画面に遷移する
                        // 予約本申し込み
                        OLS.proceed('login');
                        // 画面URL設定
                        window.history.replaceState("", "", sessionStorage.getItem("initURL"));
                        $("#contractorReserveNo").val(OLS.getSessionStorage("contractorReserveNo")).change();
                    }
                });
            }
        },

        reserveLogin: function () {

            if (!isEmpty(OLS.getSessionStorage("reservationInfo"))) {
                OLS.setReserveInfo(JSON.parse(OLS.getSessionStorage("reservationInfo")));
            } else {
                // 初めてinit apiを呼び出す
                $.ajax({
                    timeout: 1000 * 30,
                    async: false,
                    cache: false,
                    type: 'POST',
                    dataType: 'json',
                    url: '/aw/api/v1/reservation',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        reservation_number: $('#reserveNo').val(),
                        email_address: $('#reserveEmail').val()
                    }),
                    success: function (data) {
                        // 予約データを保存する
                        OLS.setSessionStorage("reservationInfo", JSON.stringify(data));
                        // 予約情報を設定
                        OLS.setReserveInfo(data);
                    }
                });
            }
        },

        setReserveInfo: function (data) {

            // 正常の場合
            reservationInfo = data;
            // 予約機種コードを設定する
            params.goodsCd = reservationInfo.goods_code;
            // 取次店舗コード
            params.agencyShopCd = reservationInfo.agency_shop_cd;
            // 流入サイト判別コード
            params.inflowSiteCd = reservationInfo.inflow_site_cd;

            // 機種選択画面を表示する
            OLS.proceed('deviceSelect');
        },

        // top画面において、SBログイン画面に遷移するか、直接機種選択画面に繊維するか決める
        judgeWhereShouldBeLocateForTop: function () {

            // loadingを表示する
            showLoading();

            // 契約状況
            var applType = $('#applType label.checked > div').attr('id');
            if (isSb != undefined && pageController) {
                var preApplType = isSb ? 'sbmember' : 'nonsbmember';
                if (applType !== preApplType) {
                    // 画面項目の初期化
                    OLS.pageInit();
                }
            }

            if (applType === 'sbmember') {
                //SBログイン画面へ遷移
                isSb = true;
                Login.jumpToMsnLogin();
            } else if (applType === 'nonsbmember') {
                //機種選択画面に遷移
                isSb = false;
                // 旧ＡＷ場合、
                if (params.displayModelKbn == '0') {
                    // 申し込み不可
                    alert(getMessage("message_alert_param",g_MsgList));
                    OLS.proceed('top');
                } else {
                    //機種選択画面に遷移
                    OLS.proceed('deviceSelect');
                }
            }
        },

        // 準備注意事項画面に遷移前処理
        goToSetup: function () {

               // 商品在庫情報
               var item = pageController.itemsInfoMap.get(pageController.currentItemCd);
               var nextPageContinueFlg = true;
               // SBユーザ、申し込み処理中、旧AW
               if(isSb
                  && accountInfo.old_model_duplicate_kbn == "1" 
                  && item.mobile_sales_wearable_kbn != "1"){
                   // 現在お申し込み処理中のため、ご利用いただけません。
                   Utils.openModal(getMessage("popup_old_model_duplicate", "popup"), getMessage("popup_button_close", "popup"));
                   nextPageContinueFlg = false;
               }

               // 下画面へ遷移FLG
               if(nextPageContinueFlg){
                   nextPageContinueFlg = displayImportantOptionAppealDialog();
               }
               if(nextPageContinueFlg){
                // loadingを表示する
                showLoading();
                
                // あんしん保証パック表示制御
                if($('.optionTopTitle .checked').length > 0){
                    safePackCheckedFlg = true;
                    safePackItemCd = item.item_code;
                }else{
                    safePackCheckedFlg = false;
                    safePackItemCd = item.item_code;
                }

                if (reservationInfo == undefined) {
                    // 予約商品の場合
                    if (item.sales_status_code == "2") {

                        // 新予約遷移のURLの設定
                        // パラメータ
                        var paramStr = [];
                        paramStr.push("applType=D"); // D固定
                        paramStr.push("goodsCd=" + pageController.currentItemCd); // 画面側選択された機種対応のitemCdの値
                        paramStr.push("agncyId=sbm"); // 固定
                        paramStr.push("reserveStsFlg=0"); // 0固定?
                        paramStr.push("receiptStyleCtrl=2"); // 2固定
                        paramStr.push("msn=" + (accountInfo ? accountInfo.msn : ''));
                        if (!isEmpty(params.agencyShopCd)) {
                            paramStr.push("agencyShopCd=" + params.agencyShopCd);
                        }

                        // チェックokの場合、新予約遷移のURLに「流入サイト判別コード」を追加する
                        if (checkInflowSiteCd(params.inflowSiteCd)) {
                            paramStr.push("inflowSiteCd=" + params.inflowSiteCd);
                        }

                        if (item.mobile_sales_wearable_kbn == "1") {
                            // 新トクするサポートの権利行使を行う機種の機種契約番号
                            if ($('#entryCollectionTrade').is(':visible') && $('input[name=privilegeUseAskSelect]:checked').val() == '1') {
                                var mcn = pageController.selected.olsCollectionTradeInInfo[pageController.selected.collectionTradeIdx].deviceMsn;
                                paramStr.push("mcn=" + mcn);
                            } else {
                                paramStr.push("mcn=" + '');
                            }
                            // ログインタイプ
                            paramStr.push("loginType=" + (accountInfo ? accountInfo.login_type : ''));

                            // 販売種別
                            paramStr.push("salesType=" + '1');
                        }

                        // 遷移前にloadingを非表示
                        hideLoading();
                        // 新予約画面へ遷移する
                        location.href = OLS_APPLY_URL + paramStr.join('&') + OLS.getSessionStorage("rediretToOrsAd");
                        return;
                    }
                    // 在庫無しの場合
                    else if (item.sales_status_code == "3") {
                        // 遷移前にloadingを非表示
                        hideLoading();
                        // お店で相談するURLへ遷移する
                        var COUNSELING_AT_STORE_URL = "https://online-shop.mb.softbank.jp/ols/applewatch/component/rect/shop.html";
                        // 新しいタブを開く
                        setTimeout(function () {
                            window.open(COUNSELING_AT_STORE_URL, '_blank');
                        }, 50);
                        return;
                    }
                }

                // ヘッダリストの表示制御
                if (!isSb && item.mobile_sales_wearable_kbn == "1") {
                    OLS.proceed('setup');
                    $('.listFlow_pay').show();
                    $('.listFlow_setup').show();
                    $('.listFlow_identity').show();
                    $('body').addClass('newAwNotSb');
                } else {
                    OLS.goToCustomerInfoEntry();
                    $('.listFlow_pay').hide();
                    $('.listFlow_setup').hide();
                    $('.listFlow_identity').hide();
                    $('body').removeClass('newAwNotSb');
                }
            }
         },

         // 支払い情報/配送画面に遷移
         backToCustomerInfoEntry: function () {
             if (isSb) {
                 OLS.proceed('sbCustomerInfoEntry');
             } else {
                OLS.proceed('nonSbCustomerInfoEntry');
             }
         },

        // 入力画面に遷移前処理
        goToCustomerInfoEntry: function () {

            // loadingを表示する
            showLoading();

            // 商品在庫情報
            var item = pageController.itemsInfoMap.get(pageController.currentItemCd);
            
            // あんしん保証パック表示制御
            if($('.optionTopTitle .checked').length > 0){
                safePackCheckedFlg = true;
                safePackItemCd = item.item_code;
            }else{
                safePackCheckedFlg = false;
                safePackItemCd = item.item_code;
            }

            if (item.mobile_sales_wearable_kbn != "1" || isSb) {
                if (reservationInfo == undefined) {
                    // 予約商品の場合
                    if (item.sales_status_code == "2") {

                        // 新予約遷移のURLの設定
                        // パラメータ
                        var paramStr = [];
                        paramStr.push("applType=D"); // D固定
                        paramStr.push("goodsCd=" + pageController.currentItemCd); // 画面側選択された機種対応のitemCdの値
                        paramStr.push("agncyId=sbm"); // 固定
                        paramStr.push("reserveStsFlg=0"); // 0固定?
                        paramStr.push("receiptStyleCtrl=2"); // 2固定
                        paramStr.push("msn=" + (accountInfo ? accountInfo.msn : ''));
                        if (!isEmpty(params.agencyShopCd)) {
                            paramStr.push("agencyShopCd=" + params.agencyShopCd);
                        }

                        // チェックokの場合、新予約遷移のURLに「流入サイト判別コード」を追加する
                        if (checkInflowSiteCd(params.inflowSiteCd)) {
                            paramStr.push("inflowSiteCd=" + params.inflowSiteCd);
                        }

                        if (item.mobile_sales_wearable_kbn == "1") {
                            // 新トクするサポートの権利行使を行う機種の機種契約番号
                            if ($('#entryCollectionTrade').is(':visible') && $('input[name=privilegeUseAskSelect]:checked').val() == '1') {
                                var mcn = pageController.selected.olsCollectionTradeInInfo[pageController.selected.collectionTradeIdx].deviceMsn;
                                paramStr.push("mcn=" + mcn);
                            } else {
                                paramStr.push("mcn=" + '');
                            }
                            // ログインタイプ
                            paramStr.push("loginType=" + (accountInfo ? accountInfo.login_type : ''));
                            // 販売種別
                            paramStr.push("salesType=" + '1');
                        }

                        // 遷移前にloadingを非表示
                        hideLoading();
                        // 新予約画面へ遷移する
                        location.href = OLS_APPLY_URL + paramStr.join('&') + OLS.getSessionStorage("rediretToOrsAd");
                        return;
                    }
                    // 在庫無しの場合
                    else if (item.sales_status_code == "3") {
                        // 遷移前にloadingを非表示
                        hideLoading();
                        // お店で相談するURLへ遷移する
                        var COUNSELING_AT_STORE_URL = "https://online-shop.mb.softbank.jp/ols/applewatch/component/rect/shop.html";
                        // 新しいタブを開く
                        setTimeout(function () {
                            window.open(COUNSELING_AT_STORE_URL, '_blank');
                        }, 50);
                        return;
                    }
                }
            }

            $('body').attr('data-isSb', isSb);

            // 顧客情報や予約情報より入力画面各項目を設定する
            if (isSb) {
                // 新機種
                if (item.mobile_sales_wearable_kbn == "1") {
                    //　暗証番号を表示
                    $("#SbhlrPasswordChecked").show();
                    thisSbHlrPasswordShowFlg = true;
                } else {
                    $("#SbhlrPasswordChecked").hide();
                    $("#sbhlrPassword").val('').change();
                    thisSbHlrPasswordShowFlg = false;
                }
                
                if(lastSbHlrPasswordShowFlg  != undefined){
                    if(thisSbHlrPasswordShowFlg != lastSbHlrPasswordShowFlg ){
                        $("#sbhlrPassword").val('').change();
                    }
                }

                lastSbHlrPasswordShowFlg = thisSbHlrPasswordShowFlg;

                // 初めて
                if (isEmpty($('#sbCustomerInfoEntry').attr('data-sbCustomerInfoEntry-isFirst'))) {

                    $('#sbContractName').text(formatPhoneNum(accountInfo.msn, '3-4-4'));
                    $('#sbContractMsn').text('電話連絡先：' + formatPhoneNum(accountInfo.telephone_number, '3-4-4'));
                    // 予約本申込みの場合
                    if (!isEmpty(reservationInfo)) {
                        // Eメールアドレス 設定要？
                        $('#sbCustomerInfoEntry #contactToEmailAddress').val(reservationInfo.email_address).change();
                        $('#sbCustomerInfoEntry #contactToEmailAddressForCheck').val(reservationInfo.email_address).change();
                        // バリデーションチェックflgを設定
                        $('#SbCustomerInfoEntry #go-to-delivery').toggleClass('disabled', preventProceed(SbCustomerInfoEntry));
                    }
                    $('#sbCustomerInfoEntry').attr('data-sbCustomerInfoEntry-isFirst', 'true');
                }

                // 契約中の番号の文言変更
                if (isTerminal) {
                    // 機種契約番号ログイン
                    $('#sbContractorUseTelNo p').text('契約中の機種契約番号');
                } else {
                    // 回線番号ログイン
                    $('#sbContractorUseTelNo p').text('契約中の電話番号');
                }

                // 職業欄
                // 権利行使する、特典を利用する
                if(viewContactJob()){
                    $("#sbJobCdChecked").show();
                    //色彩の変更
                    $("#sbContractorUseTelNo").removeClass('bgWh').addClass('bgGry');
                    // 職業のvalid状態初期化
                    resetVaildValue("sbJobCd");
                    // 職業のvalid状態更新
                    if ($('#sbJobCd').val()) {
                        $('#sbJobCd').change();
                    }
                }else{
                    $("#sbJobCdChecked").hide();
                    $('.sbContractorOffice').hide();
                    //色彩の変更
                    $("#sbContractorUseTelNo").removeClass('bgGry').addClass('bgWh');
                    // バリデーションチェック
                    $("#sbJobCd option[value='']").prop("selected", true).change();
                }

                // 次へボタン状態更新
                $('#sbCustomerInfoEntry #go-to-delivery').toggleClass('disabled', preventProceed(SbCustomerInfoEntry));
                OLS.proceed('sbCustomerInfoEntry');
            } else {
                // 新機種の場合
                if(item.mobile_sales_wearable_kbn == "1"){
                    // 分割の場合
                    var lastJobInstallmentCd = $('#jobInstallmentCd').val()
                    var jobInstallmentOption = '';
                    if(pageController.selected.installment){
                        if (viewContactJob()) {
                            jobInstallmentOption = `<option value="">選択してください</option>
                            <option value="01">会社員</option>
                            <option value="02">公務員</option>
                            <option value="03">自営業</option>
                            <option value="04">専業主婦</option>
                            <option value="05">学生</option>
                            <option value="99">その他</option>`;
                        } else {
                            jobInstallmentOption = `<option value>選択してください</option>
                            <option value="06">会社員/自営業</option>
                            <option value="07">共働き</option>
                            <option value="04">専業主婦</option>
                            <option value="08">学生/その他（同居）</option>
                            <option value="09">学生/その他（別居）</option>`;
                        }
                        $("#nationalityCdChecked").show();
                        $("#jobInstallmentCdChecked").show();
                        $('select[name=jobInstallmentCd_customerInfo]').html(jobInstallmentOption);
                        //色彩の変更
                        $("#nonSbAddressChecked").addClass('bgGry');
                        $("#nonSbTelNoChecked").addClass('nonSbCustWhiteBg');
                        $("#nonSbEmailAddressChecked").addClass('bgGry');
                        $("#nonSbAddressChecked").removeClass('nonSbCustWhiteBg');
                        $("#nonSbTelNoChecked").removeClass('bgGry');
                        $("#nonSbEmailAddressChecked").removeClass('nonSbCustWhiteBg');
                        $("#jobInstallmentCdChecked").addClass('nonSbCustWhiteBg');
                        $("#jobInstallmentCdChecked").removeClass('bgGry');
                        thisNationalShowFlg = true;
                        thisJobOnlyShowFlg = true;
                        // バリデーションチェック
                        if (lastJobInstallmentCd == '04') {
                            $('div.contractorOfficedetail').show();
                            $('#jobInstallmentCd option[value="' + lastJobInstallmentCd + '"]').prop("selected", true).change();
                        } else if ((viewContactJob() && lastJobInstallmentCd > '05' && lastJobInstallmentCd != '99')
                            || (!viewContactJob() && (lastJobInstallmentCd < '06' || lastJobInstallmentCd == '99'))
                            || lastJobInstallmentCd == '') {
                            $('div.contractorOfficedetail').hide();
                            $("#jobSupplement").val('')
                            $("input[id='officeName']").val('');
                            $("input[id='officeNameKana']").val('');
                            $("input[id='officeTelNo']").val('');
                            $("#jobInstallmentCd option[value='']").prop("selected", true);
                            NonSbCustomerInfoEntry.validated.jobInstallmentCd.valid = false;
                            $('#btn-to-delivery-pay').toggleClass('disabled', preventProceed(NonSbCustomerInfoEntry));
                            $('#btn-nonsbcus-to-agreement').toggleClass('disabled', preventProceed(NonSbCustomerInfoEntry));
                        } else {
                            $('div.contractorOfficedetail').show();
                            $('#jobInstallmentCd option[value="' + lastJobInstallmentCd + '"]').prop("selected", true).change();
                        }
                    }else{
                        if (viewContactJob()) {
                            $("#nationalityCdChecked").hide();
                            $("#jobInstallmentCdChecked").show();
                            var jobTradeOption = `<option value="">選択してください</option>
                            <option value="01">会社員</option>
                            <option value="02">公務員</option>
                            <option value="03">自営業</option>
                            <option value="04">専業主婦</option>
                            <option value="05">学生</option>
                            <option value="99">その他</option>`;
                            $('select[name=jobInstallmentCd_customerInfo]').html(jobTradeOption);
                            //色彩の変更
                            $("#nonSbAddressChecked").removeClass('bgGry');
                            $("#nonSbTelNoChecked").removeClass('nonSbCustWhiteBg');
                            $("#nonSbEmailAddressChecked").removeClass('bgGry');
                            $("#nonSbAddressChecked").addClass('nonSbCustWhiteBg');
                            $("#nonSbTelNoChecked").addClass('bgGry');
                            $("#nonSbEmailAddressChecked").addClass('nonSbCustWhiteBg');
                            $("#jobInstallmentCdChecked").addClass('bgGry');
                            $("#jobInstallmentCdChecked").removeClass('nonSbCustWhiteBg');
                            // バリデーションチェック
                            $("#jobInstallmentCdChecked option[value='']").prop("selected", true);
                            $('div.contractorOfficedetail').hide();
                            thisJobOnlyShowFlg = true;
                            thisNationalShowFlg = false;
                            if ((lastJobInstallmentCd > '05' && lastJobInstallmentCd != '99')
                                || lastJobInstallmentCd == '') {
                                $('div.contractorOfficedetail').hide();
                                $("#jobSupplement").val('')
                                $("input[id='officeName']").val('');
                                $("input[id='officeNameKana']").val('');
                                $("input[id='officeTelNo']").val('');
                                $("#jobInstallmentCd option[value='']").prop("selected", true);
                                NonSbCustomerInfoEntry.validated.jobInstallmentCd.valid = false;
                                $('#btn-to-delivery-pay').toggleClass('disabled', preventProceed(NonSbCustomerInfoEntry));
                                $('#btn-nonsbcus-to-agreement').toggleClass('disabled', preventProceed(NonSbCustomerInfoEntry));
                            } else {
                                $('div.contractorOfficedetail').show();
                                $('#jobInstallmentCd option[value="' + lastJobInstallmentCd + '"]').prop("selected", true).change();
                            }
                            $("#nationalityCd option[value='']").prop("selected", true).change();
                        } else {
                            $("#nationalityCdChecked").hide();
                            $("#jobInstallmentCdChecked").hide();
                            $('.contractorOfficedetail').hide();
                            thisNationalShowFlg = false;
                            thisJobOnlyShowFlg = false;
                            //色彩の変更
                            $("#nonSbAddressChecked").removeClass('bgGry');
                            $("#nonSbTelNoChecked").removeClass('nonSbCustWhiteBg');
                            $("#nonSbEmailAddressChecked").removeClass('bgGry');
                            $("#nonSbAddressChecked").addClass('nonSbCustWhiteBg');
                            $("#nonSbTelNoChecked").addClass('bgGry');
                            $("#nonSbEmailAddressChecked").addClass('nonSbCustWhiteBg'); 
                            // バリデーションチェック
                            $("#jobInstallmentCd option[value='']").prop("selected", true).change();
                            $("#nationalityCd option[value='']").prop("selected", true).change();
                            $('div.contractorOfficedetail').hide();
                        }
                    }
                    $("#hlrPasswordChecked").show();
                    thisHlrPasswordShowFlg = true;
                    $('#nonSbInputName').text('契約者名');
                    $('#nonSbAddress').text('契約者住所');
                    $('.addressNotice').show();
                }else{
                    $("#nationalityCdChecked").hide();
                    $("#jobInstallmentCdChecked").hide();
                    $("#hlrPasswordChecked").hide();
                    $('.contractorOfficedetail').hide();
                    thisHlrPasswordShowFlg = false;
                    thisNationalShowFlg = false;
                    thisJobOnlyShowFlg = false;
                    //色彩の変更
                    $("#nonSbAddressChecked").removeClass('bgGry');
                    $("#nonSbTelNoChecked").removeClass('nonSbCustWhiteBg');
                    $("#nonSbEmailAddressChecked").removeClass('bgGry');
                    $("#nonSbAddressChecked").addClass('nonSbCustWhiteBg');
                    $("#nonSbTelNoChecked").addClass('bgGry');
                    $("#nonSbEmailAddressChecked").addClass('nonSbCustWhiteBg');
                    // バリデーションチェック
                    $("#jobInstallmentCd option[value='']").prop("selected", true).change();
                    $("#nationalityCd option[value='']").prop("selected", true).change();
                    $("#hlrPassword").change();
                    $('#nonSbInputName').text('氏名');
                    $('#nonSbAddress').text('住所');
                    $('.addressNotice').hide();
                }
                
                if(lastHlrPasswordShowFlg != undefined){
                    if(thisHlrPasswordShowFlg != lastHlrPasswordShowFlg){
                        $("#hlrPassword").val('').change();
                    }
                }
                if(lastNationalShowFlg != undefined){
                    if(thisNationalShowFlg != lastNationalShowFlg){
                        $("#nationalityCd option[value='']").prop("selected", true).change();
                    }
                }
                if(lastJobOnlyShowFlg != undefined){
                    if(thisJobOnlyShowFlg != lastJobOnlyShowFlg){
                        $("#jobInstallmentCd option[value='']").prop("selected", true).change();
                    }
                }
                lastHlrPasswordShowFlg = thisHlrPasswordShowFlg;
                lastNationalShowFlg = thisNationalShowFlg;
                lastJobOnlyShowFlg = thisJobOnlyShowFlg;

                if (isEmpty($('#nonSbCustomerInfoEntry').attr('data-nonSbCustomerInfoEntry-isFirst'))) {

                    // 年プルダウンを設定する
                    makeJPNYearSelect($('#nonSbCustomerInfoEntry #birthDateYear'));

                    // 予約本申込みの場合
                    if (!isEmpty(reservationInfo)) {
                        // 氏名を設定
                        $('#nonSbCustomerInfoEntry #contractorNameSei').val(reservationInfo.name_sei).change();
                        $('#nonSbCustomerInfoEntry #contractorNameMei').val(reservationInfo.name_mei).change();
                        $('#nonSbCustomerInfoEntry #contractorNameSeiKana').val(reservationInfo.name_sei_kana).change();
                        $('#nonSbCustomerInfoEntry #contractorNameMeiKana').val(reservationInfo.name_mei_kana).change();
                        // 生年月日を設定
                        $("#nonSbCustomerInfoEntry #birthDateYear option[value='" + reservationInfo.birthdate_year + "']").prop("selected", true).change();
                        $("#nonSbCustomerInfoEntry #birthDateMonth option[value='" + reservationInfo.birthdate_month + "']").prop("selected", true).change();
                        $("#nonSbCustomerInfoEntry #birthDateDay option[value='" + reservationInfo.birthdate_date + "']").prop("selected", true).change();
                        // 性別
                        $("#nonSbCustomerInfoEntry [name='sexCd_customerInfo'][value='" + reservationInfo.gender + "']").click().change();
                        // 住所
                        $('#nonSbCustomerInfoEntry #contractorZipCd').val(reservationInfo.post_code).change();
                        $('#nonSbCustomerInfoEntry #addSearchFromZip').click();
                        $('#nonSbCustomerInfoEntry #contractorAddressGaiku').val('').change();
                        // 連絡先電話番号
                        $('#nonSbCustomerInfoEntry #contractorTelNo').val(reservationInfo.tel_no).change();
                        // Eメールアドレス 設定要？
                        $('#nonSbCustomerInfoEntry #contactToEmailAddress').val($('#reserveEmail').val());
                        $('#nonSbCustomerInfoEntry #contactToEmailAddressForCheck').val($('#reserveEmail').val()).change();
                        // バリデーションチェックflgを設定
                        validateItem(NonSbCustomerInfoEntry, $('#nonSbCustomerInfoEntry #contractorAddressArea'));
                        validateItem(NonSbCustomerInfoEntry, $('#nonSbCustomerInfoEntry #contractorAddressGaiku'));
                    }

                    $('#nonSbCustomerInfoEntry').attr('data-nonSbCustomerInfoEntry-isFirst', 'true');

                }

                // 新旧機種の場合、遷移ボタンの表示制御
                if (pageController.itemsInfoMap.get(pageController.currentItemCd).mobile_sales_wearable_kbn == "1") {
                     $('#btn-to-delivery-pay').show();
                     $('#btn-nonsbcus-to-agreement').hide();
                } else {
                     $('#btn-to-delivery-pay').hide();
                     $('#btn-nonsbcus-to-agreement').show();
                }
                OLS.proceed('nonSbCustomerInfoEntry');
            }
        },

        // 配送情報画面に遷移前処理
        goToDelivery: function () {

            // loadingを表示する
            showLoading();
                // 「契約住所に配送する」と「別住所への配送を希望する」選択肢を表示する
                $('#delivery #send-to-display').hide();
                $('#delivery #send-to-display-notice').hide();
                $('#delivery #send-to-form').show();
                // 新AWかつSBログインかつ一括の場合
                if (pageController.isShowCreditForSb()) {
                    // 年のプルダウンを生成
                    Utils.makeYearSelect('#creditCardTermYear');
                    // 決済方法を表示
                    $('#selectPay').show();
                } else {
                    // 決済方法を非表示
                    $('#selectPay').hide();
                }
                // バリデーションチェック
                $('#delivery select, #delivery div.sendToAddressArea input[type=text], #delivery input[type=tel], #selectPay select, #selectPay input, #otherAddress').each(function(){
                    validateItem(Delivery, $(this), true);
                });
                $('#delivery-form-submit-btn').toggleClass('disabled', preventProceed(Delivery));
                OLS.proceed('delivery');

                // 出荷元倉庫発報対応、契約者住所不備 の場合
                if (accountInfo.address_hand_input_flag) {
                    $('input[name="deliveryToAddressKbn_customerInfo"]').prop('checked', true);
                }
                // 3DセキュアOnOff取得API呼出
                var threeDOnOffInfo = {};
                threeDOnOffInfo.three_d_secure_on_off_flg = '1';
                $.ajax({
                    timeout: 1000 * 30,
                    async: false,
                    cache: false,
                    type: 'POST',
                    dataType: 'json',
                    url: '/aw/api/v1/threeDSecure',
                    contentType: 'application/json',
                    data: JSON.stringify(threeDOnOffInfo),
                    success: function (data) {
                        threeDOnOffInfoData = data;
                    },
                });
                
                var threeDSecureValidityAuthoriFlg = false;
                var threeDSecureRealAuthoriFlg = false;
                var payMethod = ''
                if(threeDOnOffInfoData != null) {
                    // 3Dセキュア有効性オーソリOnOff
                    threeDSecureValidityAuthoriFlg = threeDOnOffInfoData.three_d_secure_validity_authori_flg;
                    // 3Dセキュア実額オーソリOnOff
                    threeDSecureRealAuthoriFlg = threeDOnOffInfoData.three_d_secure_real_authori_flg;
                }
                // 分割
                if (pageController.selected.installment) {
                    // 3DセキュアOn
                    if (threeDSecureValidityAuthoriFlg) {
                        payMethod = 'credit3d2';
                        } else {
                        // 3DセキュアOff
                        payMethod = 'credit';
                    }
                } else {
                    // 一括
                    // 実額オーソリ
                    // 3DセキュアOn
                    if (threeDSecureRealAuthoriFlg) {
                        payMethod = 'credit3d2';
                    } else {
                        // 3DセキュアOff
                        payMethod = 'credit';
                    }
                }
                OLS.setSessionStorage("payMethod",payMethod);
                // 3DセキュアOff
                if(payMethod === 'credit'){
                    $(".threeDSecureAgree").hide();
                }
        },

        // 支払い情報画面に遷移前処理
        goToPay: function () {

            // バリデーションチェック 姓と名の合計文字数を45以下にする
            var lastNameLength = $('#nonSbCustomerInfoEntry #contractorNameSei').val().length;
            var firstNameLength = $('#nonSbCustomerInfoEntry #contractorNameMei').val().length;
            if (lastNameLength + firstNameLength > 45) {
                Utils.openModal(getMessage("popup_lastname_firstname_total_size", "popup"), getMessage("popup_button_close", "popup"));
                return;
            }

            // バリデーションチェック 姓(カナ)と名(カナ)の合計文字数を45以下にする
            var lastNameKanaLength = $('#nonSbCustomerInfoEntry #contractorNameSeiKana').val().length;
            var firstNameKanaLength = $('#nonSbCustomerInfoEntry #contractorNameMeiKana').val().length;
            if (lastNameKanaLength + firstNameKanaLength > 45) {
                Utils.openModal(getMessage("popup_lastnamekana_firstnamekana_total_size", "popup"), getMessage("popup_button_close", "popup"));
                return;
            }

            // バリデーションチェック 住所入力欄の郵便番号検索後のプルダウン未選択時
            if ($('#contractorAddressArea option:selected').val() == '0') {
                Utils.openModal(getMessage("popup_address_pulldown_no_select", "popup"), getMessage("popup_button_close", "popup"));
                return;
            }

            // バリデーションチェック 都道府県からの住所の合計文字数を60以下にする
            var address1Length = addressInfo[$('#contractorAddressArea option:selected').val()].length;
            var address2Length = $('#nonSbCustomerInfoEntry #contractorAddressGaiku').val().length;
            var address3Length = $('#nonSbCustomerInfoEntry #contractorAddressIncidental').val().length;
            if (address1Length + address2Length + address3Length > 60) {
                Utils.openModal(getMessage("popup_address_total_size", "popup"), getMessage("popup_button_close", "popup"));
                return;
            }

            // 生年月日の有効チェック
            var checkValidDateMsg = NonSbCustomerInfoEntry.checkValidDate();
            if (checkValidDateMsg != '') {
                Utils.openModal(checkValidDateMsg, getMessage("popup_button_close", "popup"));
                return;
            }

            // 20才以下のチェック
            var checkValidBirthDateMsg = NonSbCustomerInfoEntry.checkValidBirthDate();
            if (checkValidBirthDateMsg != '') {
                Utils.openModal(checkValidBirthDateMsg, getMessage("popup_button_close", "popup"));
                return;
            }

            //非必須入力職業場合 入力確認
            if (pageController.itemsInfoMap.get(pageController.currentItemCd).mobile_sales_wearable_kbn == "1"&& pageController.selected.installment) {
                //非必須入力職業場合
                if(!checkEmpty($('#officeName'))
                    && !checkForbiddenMoji($('#officeName').val())){
                    Utils.openModal(getMessage("popup_postcode_officeName_forbiddenMoji", "popup"), getMessage("popup_button_close", "popup"));
                    return;
                }
                if(!checkEmpty($('#officeTelNo')) && !isTelFixAndMsnAndPHS($('#officeTelNo').val())){
                    Utils.openModal(getMessage("popup_postcode_officeTelNo_telFix", "popup"), getMessage("popup_button_close", "popup"));
                    return;
                }
                if(!checkEmpty($('#officeTelNo')) && !isTelCicJudge($('#officeTelNo').val())){
                    Utils.openModal(getMessage("popup_postcode_officeTelNo_telCicJudge", "popup"), getMessage("popup_button_close", "popup"));
                    return;
                }
                var contractorOfficeMessage = '';
                if((checkEmpty($('#officeName')) || checkEmpty($('#officeNameKana')) || checkEmpty($('#officeTelNo'))) 
                        && !(checkEmpty($('#officeName')) && checkEmpty($('#officeNameKana')) && checkEmpty($('#officeTelNo')))){
                    if(checkEmpty($('#officeName'))){
                        contractorOfficeMessage += '「勤務先名」を入力（又は選択）していただく必要があります。'
                        if(checkEmpty($('#officeNameKana'))){
                            contractorOfficeMessage += '<br>「勤務先名フリガナ」を入力（又は選択）していただく必要があります。'
                        }else if(checkEmpty($('#officeTelNo'))){
                            contractorOfficeMessage += '<br>「勤務先電話番号」を入力（又は選択）していただく必要があります。'
                        }
                    }else if(checkEmpty($('#officeNameKana'))){
                        contractorOfficeMessage += '「勤務先名フリガナ」を入力（又は選択）していただく必要があります。'
                        if(checkEmpty($('#officeTelNo'))){
                            contractorOfficeMessage += '<br>「勤務先電話番号」を入力（又は選択）していただく必要があります。'
                        }
                    }else{
                        contractorOfficeMessage += '「勤務先電話番号」を入力（又は選択）していただく必要があります。'
                    }
                    Utils.openModal(contractorOfficeMessage, getMessage("popup_button_close", "popup"));
                    return;
                }
            }

            // loadingを表示する
            showLoading();
            // 3DセキュアOnOff取得API呼出
            var threeDOnOffInfo = {};
            threeDOnOffInfo.three_d_secure_on_off_flg = '1';
            $.ajax({
                timeout: 1000 * 30,
                async: false,
                cache: false,
                type: 'POST',
                dataType: 'json',
                url: '/aw/api/v1/threeDSecure',
                contentType: 'application/json',
                data: JSON.stringify(threeDOnOffInfo),
                success: function (data) {
                    threeDOnOffInfoData = data;
                },
            });
            
            var threeDSecureValidityAuthoriFlg = false;
            var threeDSecureRealAuthoriFlg = false;
            var payMethod = ''
            if(threeDOnOffInfoData != null) {
                // 3Dセキュア有効性オーソリOnOff
                threeDSecureValidityAuthoriFlg = threeDOnOffInfoData.three_d_secure_validity_authori_flg;
                // 3Dセキュア実額オーソリOnOff
                threeDSecureRealAuthoriFlg = threeDOnOffInfoData.three_d_secure_real_authori_flg;
            }
            // 分割
            if (pageController.selected.installment) {
                // 3DセキュアOn
                if (threeDSecureValidityAuthoriFlg) {
                    payMethod = 'credit3d2';
                    } else {
                    // 3DセキュアOff
                    payMethod = 'credit';
                }
            } else {
                // 一括
                // 実額オーソリ
                // 3DセキュアOn
                if (threeDSecureRealAuthoriFlg) {
                    payMethod = 'credit3d2';
                } else {
                    // 3DセキュアOff
                    payMethod = 'credit';
                }
            }
            OLS.setSessionStorage("payMethod",payMethod);
            // 3DセキュアOff
            if(payMethod === 'credit'){
                $(".threeDSecureAgree").hide();
            }
            if(pageController.selected.installment || $('#safePack .optionTitleCls').hasClass('checked')){
                $('.creditOnly').html('機種代金と月々のお支払いに利用する<br>クレジット情報を入力ください。');
            }else if(!pageController.selected.installment && !$('#safePack .optionTitleCls').hasClass('checked')){
                $('.creditOnly').html('機種代金のお支払いに利用する<br>クレジット情報を入力ください。');
            }
            // クレジットカード有効期限のカレンダーを生成。
            Utils.makeYearSelect('#billCreditCardTermYear');
            // クレジットカードのセキュリティコードの？リンク
            if ($("#billSecurityCodePopBtn")) {
                var srcUrl = getEnviromentInfo(securityCodeList);
                $("#billSecurityCodePopBtn").load(srcUrl);
            }
            if(payMethod === 'credit3d2'){
                $("#payThreeBtn").removeClass('checked');
                $("#btn-pay-to-agreement").addClass('disabled');
            }
            OLS.proceed('pay');
        },

        // 支払い情報/配送画面に遷移
        backToPayOrDelivery: function () {
            if ($("#payStyleChange").hasClass("cashDelivery")) {
                OLS.proceed('delivery');
            } else {
                $("#payThreeBtn").removeClass('checked');
                $("#btn-pay-to-agreement").addClass('disabled');
                OLS.proceed('pay');
            }
        },

        // 同意画面に遷移前処理
        goToAgreement: function () {

            var nextPageFlg = true;
            // 新機種の場合
            if (pageController.itemsInfoMap.get(pageController.currentItemCd).mobile_sales_wearable_kbn == "1" && !isSb) {

                var inputList = {
                        // ご契約者名フリガナ
                        contractor_name_sei_kana: $('#nonSbCustomerInfoEntry #contractorNameSeiKana').val(),

                        // ご契約者名フリガナ
                        contractor_name_mei_kana: $('#nonSbCustomerInfoEntry #contractorNameMeiKana').val(),

                        // 商品代金のお支払い方法
                        pay_style: '1',

                        // カード会社
                        credit_card_company_id: $('#billCreditCardCompanyId').val(),

                        // カード有効期限
                        credit_card_term: $('#billCreditCardTermMonth').val() + $('#billCreditCardTermYear').val(),

                        // カード名義（カタカナ）
                        credit_card_owner_sei: $('#billCreditCardOwnerSeiKana').val(),

                        // カード名義（カタカナ）
                        credit_card_owner_mei: $('#billCreditCardOwnerMeiKana').val()
                };
                // 支払い情報画面 apiを呼び出す
                $.ajax({
                  timeout: 1000 * 30,
                  async: false,
                  cache: false,
                  type: 'POST',
                  dataType: 'json',
                  url: '/aw/api/v1/pay',
                  contentType: 'application/json',
                  data: JSON.stringify(inputList),
                  success: function (data) {
                      // 正常の場合、下画面へ遷移
                      nextPageFlg = true;
                  },
                  beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                      // 正常以外の場合、下画面へ遷移しない
                      nextPageFlg = false;
                  }
                });
            }else{
                if (isSb) {
                    // 別住所への配送を希望する
                    if ($("#otherAddress").is(":checked")) {
                        // バリデーションチェック 住所入力欄の郵便番号検索後のプルダウン未選択時
                        if ($('#sendToAddressArea option:selected').val() == '0') {
                            Utils.openModal(getMessage("popup_address_pulldown_no_select", "popup"), getMessage("popup_button_close", "popup"));
                            return;
                        }

                        // バリデーションチェック 都道府県からの住所の合計文字数を60以下にする
                        var address1Length = addressInfo[$('#sendToAddressArea option:selected').val()].length;
                        var address2Length = $('#delivery #sendToAddressGaiku').val().length;
                        var address3Length = $('#delivery #sendToAddressIncidental').val().length;
                        if (address1Length + address2Length + address3Length > 60) {
                            Utils.openModal(getMessage("popup_address_total_size", "popup"), getMessage("popup_button_close", "popup"));
                            nextPageFlg = false;
                        }
                    }

                    if (pageController.isShowCreditForSb() && $('#payStyle02').is(':checked')) {
                        var inputList = {
                                // ご契約者名フリガナ
                                contractor_name_sei_kana: accountInfo.last_name_kana,
                                // ご契約者名フリガナ
                                contractor_name_mei_kana: accountInfo.first_name_kana,
                                // 商品代金のお支払い方法
                                pay_style: '1',
                                // カード会社
                                credit_card_company_id: $('#creditCardCompanyId').val(),
                                // カード有効期限
                                credit_card_term: $('#creditCardTermMonth').val() + $('#creditCardTermYear').val(),
                                // カード名義（カタカナ）
                                credit_card_owner_sei: $('#creditCardOwnerSei').val(),
                                // カード名義（カタカナ）
                                credit_card_owner_mei: $('#creditCardOwnerMei').val()
                        };
                        // 支払い情報画面 apiを呼び出す
                        $.ajax({
                          timeout: 1000 * 30,
                          async: false,
                          cache: false,
                          type: 'POST',
                          dataType: 'json',
                          url: '/aw/api/v1/pay',
                          contentType: 'application/json',
                          data: JSON.stringify(inputList),
                          success: function (data) {
                              // 正常の場合、下画面へ遷移
                              // nothing
                          },
                          beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                              // 正常以外の場合、下画面へ遷移しない
                              nextPageFlg = false;
                          }
                        });
                    }
                } else {

                    // バリデーションチェック 姓と名の合計文字数を45以下にする
                    var lastNameLength = $('#nonSbCustomerInfoEntry #contractorNameSei').val().length;
                    var firstNameLength = $('#nonSbCustomerInfoEntry #contractorNameMei').val().length;
                    if (lastNameLength + firstNameLength > 45) {
                        Utils.openModal(getMessage("popup_lastname_firstname_total_size", "popup"), getMessage("popup_button_close", "popup"));
                        nextPageFlg = false;
                    }

                    // バリデーションチェック 姓(カナ)と名(カナ)の合計文字数を45以下にする
                    var lastNameKanaLength = $('#nonSbCustomerInfoEntry #contractorNameSeiKana').val().length;
                    var firstNameKanaLength = $('#nonSbCustomerInfoEntry #contractorNameMeiKana').val().length;
                    if (lastNameKanaLength + firstNameKanaLength > 45) {
                        Utils.openModal(getMessage("popup_lastnamekana_firstnamekana_total_size", "popup"), getMessage("popup_button_close", "popup"));
                        nextPageFlg = false;
                    }

                    // バリデーションチェック 住所入力欄の郵便番号検索後のプルダウン未選択時
                    if ($('#contractorAddressArea option:selected').val() == '0') {
                        Utils.openModal(getMessage("popup_address_pulldown_no_select", "popup"), getMessage("popup_button_close", "popup"));
                        return;
                    }

                    // バリデーションチェック 都道府県からの住所の合計文字数を60以下にする
                    var address1Length = addressInfo[$('#contractorAddressArea option:selected').val()].length;
                    var address2Length = $('#nonSbCustomerInfoEntry #contractorAddressGaiku').val().length;
                    var address3Length = $('#nonSbCustomerInfoEntry #contractorAddressIncidental').val().length;
                    if (address1Length + address2Length + address3Length > 60) {
                        Utils.openModal(getMessage("popup_address_total_size", "popup"), getMessage("popup_button_close", "popup"));
                        nextPageFlg = false;
                    }

                    // 生年月日の有効チェック
                    var checkValidDateMsg = NonSbCustomerInfoEntry.checkValidDate();
                    if (checkValidDateMsg != '') {
                        Utils.openModal(checkValidDateMsg, getMessage("popup_button_close", "popup"));
                        nextPageFlg = false;
                    }

                    // 20才以下のチェック
                    var checkValidBirthDateMsg = NonSbCustomerInfoEntry.checkValidBirthDate();
                    if (checkValidBirthDateMsg != '') {
                        Utils.openModal(checkValidBirthDateMsg, getMessage("popup_button_close", "popup"));
                        nextPageFlg = false;
                    }
                }
            }

            if(nextPageFlg){
                // loadingを表示する
                showLoading();

                // 商品在庫情報
                var item = pageController.itemsInfoMap.get(pageController.currentItemCd);
                if (item.mobile_sales_wearable_kbn == "1") {
                    $('#comfirm').show();
                    $('#machineInfoAgree').show();
                } else {
                    $('#comfirm').hide();
                    $('#machineInfoAgree').hide();
                }

                var agreeDiv = $('#installmentBuyContractAgree');
                if (pageController.selected.installment) {
                    agreeDiv.insertBefore($('#personalInfoAgree'));
                    agreeDiv.show();
                } else {
                    agreeDiv.hide();
                }

                // 新トクするサポート注意事項表示制御
                if ($('#tokusapoPlusDiv').css('display') !== 'none') {
                    $('#newTokusuruSupport').show();
                } else {
                    $('#newTokusuruSupport').hide();
                }

                // 新トクするサポート特典利用に関する注意事項
                if ($('#entryCollectionTrade').css('display') === 'block' 
                    && $('#collectionTradeInPrivilegeUseSelect').css('display') === 'block'
                    && $('input[name="privilegeUseSelect"]:checked').val().split(',')[0] === TOKUSURU_SUPPORT_JUDGE_KBN.newTokusuruSupport){
                    $('#newTokusuruSupportInfo').show();
                } else {
                    $('#newTokusuruSupportInfo').hide();
                }

                // 下取りに関する同意事項表示制御
                if ($('#entryCollectionTrade').css('display') === 'block' 
                    && $('#collectionTradeInPrivilegeUseSelect').css('display') === 'block'
                    && isTradeInProgram($('input[name="privilegeUseSelect"]:checked').val().split(',')[0])){
                    $('#campaignInfo').show();
                } else {
                    $('#campaignInfo').hide();
                }

                agreeCtl.agreeLoad();
                OLS.proceed('agreement');
            }
        },

        goToConfirm: function () {
            confirmController();
            if (!isSb && pageController.itemsInfoMap.get(pageController.currentItemCd).mobile_sales_wearable_kbn == "1") {
                $('#go-to-complete span').html("申し込み内容を確定して、次に進む");
            } else {
                $('#go-to-complete span').html("申し込み内容を確定する");
            }
            OLS.proceed('confirm');
        },

        goToComplete: function () {
            if (!(pageController.itemsInfoMap.get(pageController.currentItemCd).mobile_sales_wearable_kbn == '1' && !isSb)) {
                if (getEnviromentInfo(SBPS_COMMUNICATION_FLG) === '1') {
                    sbpsWindow = window.open(TDS2_APPROVEURL_HOST + TDS2_APPROVEURL_URL, 'sbpsTds');
                    
                } else {
                    sbpsWindow = window.open(sbpsTdsSuccessUrl + '?res_tracking_id=123456&res_result=OK');
                }
            }
            // 申込登録リクエスト情報作成
            applyRegistInfoCreate();

            // 二重送信を防ぐ実装
            $("#go-to-complete").addClass("disabled");

            // loadingを表示する
            showLoading();

            // loadingを書けるように
            setTimeout(function () {

                // 利用ポイントの設定
                // SBの場合
                if (isSb) {
                    // 割賦
                    if (pageController.selected.installment) {
                        // 利用ポイント
                        applyRegistInfo.usage_point = nullToZero(removeComma($("#conf_usedInstallmentPoint").val()));
                        // 同一請求グループ内のポイントを含める
                        applyRegistInfo.include_same_bill_group = "false";
                        // 一括
                    } else {
                        // 利用ポイント
                        applyRegistInfo.usage_point = nullToZero(removeComma($("#conf_usedLumpPoint").val()));
                        // 同一請求グループ内のポイントを含める
                        applyRegistInfo.include_same_bill_group = "false";
                    }
                    // 非SBの場合
                } else {
                    // 利用ポイント
                    applyRegistInfo.usage_point = "0";
                    // 同一請求グループ内のポイントを含める
                    applyRegistInfo.include_same_bill_group = "false";
                }

                // 登録前の禁則文字変換
                applyRegistInfo.address_block = replaceForbidden(applyRegistInfo.address_block);
                applyRegistInfo.address_incidental = replaceForbidden(applyRegistInfo.address_incidental);
                applyRegistInfo.first_name = replaceForbidden(applyRegistInfo.first_name);
                applyRegistInfo.first_name_kana = replaceForbidden(applyRegistInfo.first_name_kana);
                applyRegistInfo.last_name = replaceForbidden(applyRegistInfo.last_name);
                applyRegistInfo.last_name_kana = replaceForbidden(applyRegistInfo.last_name_kana);

                // 流入サイト判別コード
                applyRegistInfo.inflow_site_cd = isEmpty(params.inflowSiteCd) ? null : params.inflowSiteCd;

                if (pageController.itemsInfoMap.get(pageController.currentItemCd).mobile_sales_wearable_kbn == '1' && !isSb) {
                    OLS.proceed('identity');

                    // 本人確認書類画面の画像認証
                    $('#kaptchaImg').attr('src', '/aw/Kaptcha.jpg?v=' + new Date().getTime());
                    $('#kaptchaCode').val('');
                    // 選択した画像を送るボタンを非活性になる
                    $("#identity-go-to-complete").addClass("disabled");
                    // 使用者本人確認書類選択プルダウンを設定する
                    OLS.makePulldown();
                } else {
                    var sbpsCompleteFlg = false;

                    // SBかつ、支払方法がクレカの場合かつ、購入方法が割賦以外（一括・通常）の場合
                    if (pageController.isShowCreditForSb() && $('#payStyle02').is(':checked')) {
                        // クレジットカード
                        var creditCardNo = $("input[name='creditCardNo_customerInfo']").val();

                        // セキュリティコード
                        var creditCardSecurityCode = $("#securityCode").val();

                        var cardUseTermMonth = $("select[name='creditCardTermMonth_customerInfo']").val();
                        var cardUseTermYear = $("select[name='creditCardTermYear_customerInfo']").val();
                        // カード有効期限
                        var creditCardTerm = cardUseTermYear + cardUseTermMonth;

                        var year = '';
                        var month = '';
                        var day = '';
                        year = accountInfo.birth_day.substr(0, 4);
                        month = accountInfo.birth_day.substr(4, 2);
                        day = accountInfo.birth_day.substr(6, 2);

                        // 生年月日
                        var birthDate = year + month + day;

                        var token = '';
                        var tokenKey = '';
                        var tds2infoToken = '';
                        var tds2infoTokenKey = '';

                        if (creditCardNo !== '') {
                            var torResponse = branchTorToken(creditCardNo);

                            var errorMessage = torResponseChecked(torResponse);
                            if (errorMessage === '') {
                                applyRegistInfo['token_pan'] = torResponse.authoriResponseInfo.creditCardNbr;
                                applyRegistInfo['sbps_credit_company_cd'] = torResponse.authoriResponseInfo.cafisResponseInfo.creditCardCompanyId;
                                // SBPSワンタイムトークンのjs処理が読み込めているかチェックする
                                var communicationCheckResult = sbpsCommunicationCheck();

                                if (communicationCheckResult) {
                                    sbpsCompleteFlg = true;
                                  branchSbpsToken(creditCardNo, creditCardTerm, creditCardSecurityCode, function(sbpsResponse) {
                                      if (sbpsResponse.result === 'OK') {
                                          token = sbpsResponse.tokenResponse.token;
                                          tokenKey = sbpsResponse.tokenResponse.tokenKey;
                                          applyRegistInfo['pay_token'] = token;
                                          applyRegistInfo['pay_token_key'] = tokenKey;
                                          
                                          // SBPSカード利用者決済情報トークンのjs処理が読み込めているかチェックする
                                          var tds2CommunicationCheckResult = sbpsTds2CommunicationCheck();
                                          if (tds2CommunicationCheckResult) {
                                              sbpsCompleteFlg = true;
                                              var postCode = applyRegistInfo.post_code.slice(0,3)+ applyRegistInfo.post_code.slice(4);
                                              var sbpsTds2Response = branchSbpsTds2Token(postCode, applyRegistInfo.telephone_number, applyRegistInfo.mail_address, function(sbpsTds2Response) {
                                                  if (sbpsTds2Response.result === 'OK') {
                                                      tds2infoToken = sbpsTds2Response.tokenResponse.tds2infoToken;
                                                      tds2infoTokenKey = sbpsTds2Response.tokenResponse.tds2infoTokenKey;
                                                      
                                                      var threeDSecureOnOffInfo = {};
                                                      threeDSecureOnOffInfo.three_d_secure_on_off_flg = '2';
                                                      threeDSecureOnOffInfo.token = token;
                                                      threeDSecureOnOffInfo.token_key = tokenKey;
                                                      threeDSecureOnOffInfo.tds2info_token = tds2infoToken;
                                                      threeDSecureOnOffInfo.tds2info_token_key = tds2infoTokenKey;
                                                      threeDSecureOnOffInfo.installment = pageController.selected.installment;
                                                      threeDSecureOnOffInfo.security_code = creditCardSecurityCode;
                                                      var threeDSecureOnOffInfoData = null;
                                                      $.ajax({
                                                          timeout: 1000 * 30,
                                                          async: false,
                                                          cache: false,
                                                          type: 'POST',
                                                          dataType: 'json',
                                                          url: '/aw/api/v1/threeDSecure',
                                                          contentType: 'application/json',
                                                          data: JSON.stringify(threeDSecureOnOffInfo),
                                                          success: function (data) {
                                                              threeDSecureOnOffInfoData = data;
                                                          },
                                                      });
                                                      var threeDSecureValidityAuthoriFlg = false;
                                                      var threeDSecureRealAuthoriFlg = false;
                                                      var freeCsv = '';
                                                      var orderIdSeq = '';
                                                      if (threeDSecureOnOffInfoData != null) {
                                                          // 3Dセキュア有効性オーソリOnOff
                                                          threeDSecureValidityAuthoriFlg = threeDSecureOnOffInfoData.three_d_secure_validity_authori_flg;
                                                          // 3Dセキュア実額オーソリOnOff
                                                          threeDSecureRealAuthoriFlg = threeDSecureOnOffInfoData.three_d_secure_real_authori_flg;
                                                          // フリー項目
                                                          freeCsv = threeDSecureOnOffInfoData.free_csv;
                                                          // 購入 IDのSEQ
                                                          orderIdSeq = threeDSecureOnOffInfoData.order_id_seq;
                                                      }
                                                      var payMethod = '';
                                                      var amount = '';
                                                      // 分割
                                                      if (pageController.selected.installment) {
                                                          // 有効性オーソリ
                                                          amount = '1';
                                                          // 3DセキュアOn
                                                          if (threeDSecureValidityAuthoriFlg) {
                                                              payMethod = 'credit3d2';
                                                              applyRegistInfo['tds_agree_flg'] = '1';
                                                              } else {
                                                              // 3DセキュアOff
                                                              payMethod = 'credit';
                                                              applyRegistInfo['tds_agree_flg'] = '';
                                                          }
                                                      } else {
                                                          // 一括
                                                          // 実額オーソリ
                                                          amount = removeComma($("#priceBox .mobilePrice.selected").text());
                                                          // 3DセキュアOn
                                                          if (threeDSecureRealAuthoriFlg) {
                                                              payMethod = 'credit3d2';
                                                              applyRegistInfo['tds_agree_flg'] = '1';
                                                          } else {
                                                              // 3DセキュアOff
                                                              payMethod = 'credit';
                                                              applyRegistInfo['tds_agree_flg'] = '';
                                                          }
                                                      }
                                                      var orderId = orderIdSeq;
                                                      TDS2_ORDER_ID = orderId;
                                                      var tmp = document.cookie.split('; ');
                                                      var arr = new Array();
                                                      for(var i = 0; i < tmp.length; i++)    {
                                                          var data = tmp[i].split('=');
                                                          arr[data[0]] = decodeURIComponent(data[1]);
                                                      }
                                                      TDS2_APPROVE_JSESSION_ID = arr['JSESSIONID'];
                                                      if (envirment_id == 'pr'){
                                                          TDS2_APPROVE_PR1 = arr['VrFd7CfwmniRGgZT4VPv+zvOa9Mb4INZftjI-tKumCumHF2MXbiQuwLCwmi4KmdzLU0_'];
                                                          TDS2_APPROVE_PR2 = arr['VrFd7CfwmniRGgdX7VLv+zvOa98N4INZftjI-tKumCumHF2MXrGOogXUwnTVKQF7JQ__'];
                                                      } else {
                                                          TDS2_APPROVE_ST = arr['VrFd7CfwmniRGgZT4VPv+zvOa9Mb4INZftjI-tKumCumHF2MXbSJogDb3mu4KmdzLU0_'];
                                                      }
                                                      var sbpsTdsSuccessUrl = window.origin + '/aw/callbackSbps';
                                                      var sbpsTdsErrorUrl = window.origin + '/aw/callbackSbps';
                                                      var requestDate = getTimeAll()

                                                      var sbpsTdsParams = {
                                                              // 支払方法
                                                              "pay_method" : payMethod,
                                                              // マーチャント ID
                                                              "merchant_id" : "24407",
                                                              // サービス ID
                                                              "service_id" : "001",
                                                              // 顧客 ID
                                                              "cust_code" : "SBOLS",
                                                              // 購入 ID
                                                              "order_id" :orderId,
                                                              // 商品 ID
                                                              "item_id" : "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX",
                                                              // 金額（税込）
                                                              "amount" : amount,
                                                              // 購入タイプ
                                                              "pay_type" : '0',
                                                              // サービスタイプ
                                                              "service_type" : '0',
                                                              // 顧客利用端末タイプ 0：PC
                                                              "terminal_type" : '0',
                                                              // 決済完了時 URL
                                                              "success_url" : sbpsTdsSuccessUrl,
                                                              // 決済キャンセル時 URL
                                                              "cancel_url" : sbpsTdsErrorUrl,
                                                              // エラー時 URL
                                                              "error_url" : sbpsTdsErrorUrl,
                                                              // 決済通知用 CGI
                                                              "pagecon_url" : getEnviromentInfo(KIWI_URL) + '/kw/e0uspq/v1/sbols/api/v1/receivePurchaseResult',
                                                              // フリー項目
                                                              "free_csv" : freeCsv,
                                                              // リクエスト日時
                                                              "request_date" : requestDate
                                                      };
                                                      var paramStr = '';
                                                      for(var num in sbpsTdsParams){
                                                          paramStr += sbpsTdsParams[num];
                                                      }
                                                      
                                                      // チェックサム
                                                      // パラメータ結合
                                                      var hashString = '';
                                                      var threeDSecureInfo = {};
                                                      threeDSecureInfo.three_d_secure_on_off_flg = '3';
                                                      threeDSecureInfo.param_str = paramStr;
                                                      threeDSecureInfo.dmsnFlg = '1';
                                                      var threeDSecureInfoData = null;
                                                     // 3DセキュアOnOff取得API呼出
                                                      $.ajax({
                                                          timeout: 1000 * 30,
                                                          async: false,
                                                          cache: false,
                                                          type: 'POST',
                                                          dataType: 'json',
                                                          url: '/aw/api/v1/threeDSecure',
                                                          contentType: 'application/json',
                                                          data: JSON.stringify(threeDSecureInfo),
                                                          success: function (data) {
                                                              threeDSecureInfoData = data;
                                                          },
                                                      });
                                                      if (threeDSecureInfoData.status_cd != '0') {
                                                          location.replace(ERROR_URL + '?errorMessage=' + encodeURIComponent(getMessage("message_error_sbps", "errPage")))
                                                      } else {
                                                          if (threeDSecureInfoData != null) {
                                                              hashString = threeDSecureInfoData.hash_string;
                                                          }
                                                          var sbpsTdsParamStr = '';
                                                          sbpsTdsParams["sps_hashcode"] = hashString;
                                                          for(var num in sbpsTdsParams){
                                                              sbpsTdsParamStr += num+'='+ encodeURIComponent(sbpsTdsParams[num]) + '&';
                                                          }
                                                          
                                                          var sbpsWindowTimer = setInterval(function(){
                                                              if (sbpsWindow.closed){
                                                                  $("#go-to-complete").removeClass("disabled");
                                                                  clearInterval(sbpsWindowTimer);
                                                              }
                                                          
                                                          },1000);
                                                          
                                                          // GAサイト分析
                                                          var pageName = "aw_sbpsRequest_" + TDS2_ORDER_ID;
                                                          var gaString = getEnviromentInfo(gaList);
                                                          if (gaString) {
                                                              window.dataLayer.push({'pageUrl': '/' + pageName + '.html', 'event': 'olsEcFlow'});
                                                          }

                                                          sbpsWindow.postMessage(sbpsTdsParamStr.slice(0,-1), window.location.protocol + '//' + window.location.host);
                                                      }

                                                  } else {
                                                      sbpsCompleteFlg = false;
                                                      if (sbpsWindow != undefined) {
                                                          sbpsWindow.close();
                                                      }

                                                      // 処理エラーの場合アラート表示(連打防止のためエラーポップアップの表示を1秒遅らせる）
                                                      setTimeout(function() {
                                                          Utils.openModal(getMessage("popup_msg_sbps_system", "popup"), getMessage("popup_button_close", "popup"));
                                                          // 「申し込み内容を確定する」ボタンを活性化
                                                          $("#go-to-complete").removeClass("disabled");
                                                      },1000);
                                                      return false;
                                                  } 
                                              });
                                              
                                          } else {
                                              sbpsCompleteFlg = false;
                                              if (sbpsWindow != undefined) {
                                                  sbpsWindow.close();
                                              }

                                              // 処理エラーの場合アラート表示(連打防止のためエラーポップアップの表示を1秒遅らせる）
                                              setTimeout(function() {
                                                  Utils.openModal(getMessage("popup_msg_sbps_system", "popup"), getMessage("popup_button_close", "popup"));
                                                  // 「申し込み内容を確定する」ボタンを活性化
                                                  $("#go-to-complete").removeClass("disabled");
                                              },1000);
                                              return false;
                                          }
                                      } else {
                                          sbpsCompleteFlg = false;
                                          if (sbpsWindow != undefined) {
                                              sbpsWindow.close();
                                          }

                                          // 処理エラーの場合アラート表示(連打防止のためエラーポップアップの表示を1秒遅らせる）
                                          setTimeout(function() {
                                              Utils.openModal(getMessage("popup_msg_sbps_system", "popup"), getMessage("popup_button_close", "popup"));
                                              // 「申し込み内容を確定する」ボタンを活性化
                                              $("#go-to-complete").removeClass("disabled");
                                          },1000);
                                          return false;
                                      }  
                                  });

                                    
                                } else {
                                    if (sbpsWindow != undefined) {
                                        sbpsWindow.close();
                                    }
                                 // アラート表示(連打防止のためエラーポップアップの表示を1秒遅らせる）
                                    setTimeout(function() {
                                        Utils.openModal(errorMessage, getMessage("popup_button_close", "popup"));
                                        // 「申し込み内容を確定する」ボタンを活性化
                                        $("#go-to-complete").removeClass("disabled");
                                    },1000);
                                    return false;
                                }
                            } else {
                                if (sbpsWindow != undefined) {
                                    sbpsWindow.close();
                                }
                                // アラート表示(連打防止のためエラーポップアップの表示を1秒遅らせる）
                                setTimeout(function() {
                                    Utils.openModal(errorMessage, getMessage("popup_button_close", "popup"));
                                    // 「申し込み内容を確定する」ボタンを活性化
                                    $("#go-to-complete").removeClass("disabled");
                                },1000);
                                return false;
                            }
                        } else {
                            if (sbpsWindow != undefined) {
                                sbpsWindow.close();
                            }
                        }
                    } else {
                        if (sbpsWindow != undefined) {
                            sbpsWindow.close();
                        }
                    }

                    // 伝票登録API呼出
                    if (!sbpsCompleteFlg) {
                        $.ajax({
                            timeout: 1000 * 30,
                            async: false,
                            cache: false,
                            type: 'POST',
                            dataType: 'json',
                            url: '/aw/api/v1/orders',
                            contentType: 'application/json',
                            data: JSON.stringify(applyRegistInfo),
                            success: function (data) {
                                Complete.displayEmail();
                                Complete.displayApplicationNumber(data.accept_number);
                                Complete.setEntryInfoComfirmUrl();
                                Complete.setWtrTag(data.accept_number);
                                OLS.proceed('complete');
                            },
                            beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                                if (!isEmpty(jqXHR.responseJSON) &&
                                    !isEmpty(jqXHR.responseJSON.error) &&
                                    !isEmpty(jqXHR.responseJSON.error.code)) {
                                    // 利用ポイントが不足して場合。
                                    if (jqXHR.responseJSON.error.code == "AW400018") {
                                        this.afterCommonErrorModalClosed = function () {
                                            getPoint();
                                            $('body,html').animate({
                                                scrollTop: $(".pointTitle:visible").offset().top - 150
                                            }, 300);
                                        };
                                    }
                                }
                                // 「申し込み内容を確定する」ボタンを活性化
                                $("#go-to-complete").removeClass("disabled");
                            }
                        });
                    }
                }
            }, 10);
        },

        identityGoToComplete: function () {
            // 二重送信を防ぐ実装
            $("#identity-go-to-complete").addClass("disabled");
            if (getEnviromentInfo(SBPS_COMMUNICATION_FLG) === '1') {
                sbpsWindow = window.open(TDS2_APPROVEURL_HOST + TDS2_APPROVEURL_URL, 'sbpsTds');
                
            } else {
                sbpsWindow = window.open(sbpsTdsSuccessUrl + '?res_tracking_id=123456&res_result=OK');
            }

            // 本人確認書類送付方法
            applyRegistInfo['id_document_send_style'] = '3';

            // 画像アップロード画像の取得
            identityNext();

            //本人確認書類リスト
            if (uploadFilesListId != null && uploadFilesListId != ""){

                // 契約書情報入力画面で登録した本人確認書類は、
                // 最後尾に区切り文字が無い場合、後続のループ処理で
                // カウンター（uploadFileNameListCount）がオーバーする。
                var jsonObjCode = uploadFilesListId.split(";");
                var jsonObjName = uploadFilesListName.split(";");
                var uploadFileNameListCount = 0;

                var array1 = [];
                var pageNo = 1;

                for(var upfilecnt = 0; upfilecnt < jsonObjCode.length; upfilecnt++) {

                    if (jsonObjCode.length <= uploadFileNameListCount) {
                        break;
                    }

                    // 内部変換した書類コードを、伝票登録ように再変換するためにsubstrする
                    var idDocumentCd = jsonObjCode[uploadFileNameListCount].substr(0, 3);

                    for(var uploadFileCount = 0; uploadFileCount< jsonObjCode.length; uploadFileCount++){

                        if(jsonObjCode[uploadFileNameListCount] != null
                            && jsonObjCode[uploadFileNameListCount] != ""
                            && idDocumentCd === jsonObjCode[uploadFileNameListCount].substr(0, 3)){

                            array1.push({
                                'id_document_cd': jsonObjCode[uploadFileNameListCount],
                                'upload_file_name' : jsonObjName[uploadFileNameListCount],
                                'page_no' : pageNo
                            });

                            uploadFileNameListCount++;
                            pageNo++;
                        }
                    }
                }
                applyRegistInfo['id_document_form_list'] = array1;
            }

            // 画像認証 入力コードチェック
            $.ajax({
                timeout: 1000 * 30,
                async: false,
                cache: false,
                type: 'POST',
                dataType: 'json',
                url: '/aw/api/v1/kaptchaCodeCheck',
                contentType: 'application/json',
                data: JSON.stringify({
                    kaptchaCd: $('#kaptchaCode').val()
                }),
                success: function (data) {
                    executeEntrySlip();
                },
                beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                    if (sbpsWindow != undefined) {
                        sbpsWindow.close();
                    }
                    // 認証画像再読み込み
                    $('#kaptchaImgChange').click();
                    // コード入力欄初期化
                    $('#kaptchaCode').val('');
                    // リンク・ボタン活性/非活性制御
                    imgSendSet();
                    // 「申し込み内容を確定する」ボタンを活性化
                    $("#identity-go-to-complete").removeClass("disabled");
                }
            });
        },
        // 使用者本人確認書類選択プルダウンを設定する
        makePulldown: function () {
            // 契約者情報入力画面より国籍を取得
            var nationalityCd = '';
            if ($('#nationalityCdChecked').css('display') === 'flex') {
                nationalityCd = $("select[name='nationalityCd_customerInfo'] option:selected").val();
            }
            // 住所コード
            var address_code = $("#contractorAddressArea option:selected").val();
            $.ajax({
                timeout: 1000 * 30,
                async: false,
                cache: false,
                type: 'POST',
                dataType: 'json',
                url: '/aw/api/v1/idDocument/init',
                contentType: 'application/json',
                data: JSON.stringify({
                    nationalityCd: nationalityCd,
                    addressCode: address_code
                }),
                success: function (data) {
                    if (isAlreadyDrownIdDocumentListlength != data.IdntConfirmSendScrnDispResDto.IdDocumentGroupList.length) {
                        isAlreadyDrownIdDocumentListlength = data.IdntConfirmSendScrnDispResDto.IdDocumentGroupList.length;
                        json = data;
                        // 本人確認書類の種類選択の初期化
                        $('#idDocumentGroupCd').html("");

                        var str = '';
                        var mapList = data.IdntConfirmSendScrnDispResDto.IdDocumentGroupList;
                        for (var i in mapList) {
                            str = str + "<option value='" + mapList[i]["idDocumentGroupCd"] + "'>" + mapList[i]["idDocumentGroupName"] + "</option>";
                        }
                        $("#idDocumentGroupCd").append(str);
                        if (nationalityCd == "01") {
                            // 在留カード（一般永住者）を設定する
                            $("#documentDiv #idDocumentGroupCd").val("X");
                        } else if (nationalityCd == "02") {
                            // 在留カード + 外国パスポートを設定する
                            $("#documentDiv #idDocumentGroupCd").val("s");
                        } else {
                            // 運転免許証を設定する
                            $("#documentDiv #idDocumentGroupCd").val("1");
                        }
                        // 画面制御処理の初期表示
                        documentChange(data);
                    }
                }
            });
        },

        proceed: function (p) {

            // loadingを表示する
            location.hash = 'loading';
            showLoading();

            // パンくずを残して
            $('body > div#' + p + ', body > div#container > main#' + p).addClass('history');
            // 上まで飛ぶ  
            goToTop(1); // 0 効かないので 1 にした
            location.hash = p;

            // WTRのタグ（S_NO）埋め込み
            Utils.setWtrSno();

            // GAサイト分析
            var gaString = getEnviromentInfo(gaList);
            if (gaString) {
                setTimeout(gaString, 50);
            }
        },

        // 決済方法の切り替え
        changePayMethod : function (isCreditCard) {
            // クレジットカード
            if (isCreditCard) {
                $("#payStyle02").prop("checked", true);
                $("#payStyleCreditCard").addClass('checked');
                $("#payStyle01").prop("checked", false);
                $("#payStyleCOD").removeClass('checked');
                // セキュリティコード？
                if ($("#creditCardSecurityCodePopBtn")) {
                    var srcUrl = getEnviromentInfo(securityCodeList);
                    $("#creditCardSecurityCodePopBtn").load(srcUrl);
                }
                // クレジットカード情報を表示
                $("#creditCardDetails").show();
            } else {
                $("#payStyle02").prop("checked", false);
                $("#payStyleCreditCard").removeClass('checked');
                $("#payStyle01").prop("checked", true);
                $("#payStyleCOD").addClass('checked');
                $('#delivery .allAgreeBtn label').removeClass('checked');
                // クレジットカード情報を非表示
                $("#creditCardDetails").hide();
            }
            // バリデーションチェック
            $('#delivery select, #delivery div.sendToAddressArea input[type=text], #delivery input[type=tel], #selectPay select, #selectPay input, #otherAddress').each(function(){
                validateItem(Delivery, $(this), true);
            });
            // ボタン制御
            $('#delivery-form-submit-btn').toggleClass('disabled', preventProceed(Delivery));
        },

        pageInit: function () {
            // 画面項目の初期化
            // ------------------
            // 機種選択画面
            // ------------------
            initDoneFlag = false;
            $('.sba-identity[title="s_no"]').remove();

            // ------------------
            // お客さま情報入力 非SB
            // ------------------
            // 氏名
            $('#nonSbCustomerInfoEntry #contractorNameSei').val('');
            $('#nonSbCustomerInfoEntry #contractorNameMei').val('');
            $('#nonSbCustomerInfoEntry #contractorNameSeiKana').val('');
            $('#nonSbCustomerInfoEntry #contractorNameMeiKana').val('');
            // 生年月日
            $("#nonSbCustomerInfoEntry #birthDateYear option[value='']").prop("selected", true);
            $("#nonSbCustomerInfoEntry #birthDateMonth option[value='']").prop("selected", true);
            $("#nonSbCustomerInfoEntry #birthDateDay option[value='']").prop("selected", true);
            // 性別
            $("#nonSbCustomerInfoEntry [name='sexCd_customerInfo']:checked").prop("checked", false).parent().removeClass("checked");
            // 住所
            $('#nonSbCustomerInfoEntry #contractorZipCd').val('');
            $('#nonSbCustomerInfoEntry .contractorAddressArea').hide();
            $('#contractorAddressArea').html('');
            $('#addSearchFromZipSelect').hide();
            $('#nonSbCustomerInfoEntry #contractorAddressGaiku').val('');
            $('#nonSbCustomerInfoEntry #contractorAddressIncidental').val('');
            // 連絡先電話番号
            $('#nonSbCustomerInfoEntry #contractorTelNo').val('');
            // Eメールアドレス
            $('#nonSbCustomerInfoEntry #contactToEmailAddress').val('');
            $('#nonSbCustomerInfoEntry #contactToEmailAddressForCheck').val('');
            // 支払い情報の入力に進む
            $('#btn-to-delivery-pay').addClass('disabled');
            // 規約同意に進む
            $('#btn-nonsbcus-to-agreement').addClass('disabled');

            // ------------------
            // お客さま情報入力 SB
            // ------------------
            // 連絡先電話番号
            $('#sbCustomerInfoEntry #contactTelNo').val('');
            $('#sbCustomerInfoEntry #sb-customerinfo-tel-num-input').hide();
            // Eメールアドレス
            $('#sbCustomerInfoEntry #contactToEmailAddress').val('');
            $('#sbCustomerInfoEntry #contactToEmailAddressForCheck').val('');

            // ------------------
            // 配送情報入力
            // ------------------
            // 配送先
            $("#delivery [name='deliveryToAddressKbn_customerInfo']:checked").prop("checked", false);
            $('#delivery .checked').removeClass("checked");
            $("#delivery #threeDAgree").prop("checked", false);
            $("#delivery .checked").removeClass("checked");
            // 別の住所
            $('#delivery #deliveryToAddressInputArea').hide();
            $('#delivery #sendToZipCd').val('');
            $('#delivery .sendToAddressArea').hide();
            $('#delivery #sendToAddSearchFromZipSelect').hide();
            $('#delivery #sendToAddressGaiku').val('');
            $('#delivery #sendToAddressIncidental').val('');

            // ------------------
            // 支払い情報入力
            // ------------------
            // 支払い情報
            // カード番号
            $('#pay #billCreditCardNo').val('');
            // セキュリティコード
            $('#pay #billSecurityCode').val('');
            // カード名義フリガナ
            $('#pay #billCreditCardOwnerSeiKana').val('');
            $('#pay #billCreditCardOwnerMeiKana').val('');
            // カード会社名
            $("#pay #billCreditCardCompanyId option[value='']").prop("selected", true);
            // カード有効期限
            $("#pay #billCreditCardTermMonth option[value='']").prop("selected", true);
            $("#pay #billCreditCardTermYear option[value='']").prop("selected", true);
            //3Dセキュア
            $("#pay #threeDAgree").prop("checked", false);
            $("#pay .checked").removeClass("checked");
            // 規約同意に進む
            $('#btn-pay-to-agreement').addClass('disabled');

            // ------------------
            // 規約同意
            // ------------------
            $("#agreement #allAgree").prop("checked", false);
            $("#agreement .checked").removeClass("checked");
            // 申し込み内容の確認に進む
            $('#go-to-confirm').addClass('disabled');

            // ------------------
            // 確認画面
            // ------------------
            // 利用するポイント
            $('#confirm #conf_usedInstallmentPoint').val('0');
            $('#confirm #conf_usedLumpPoint').val('0');
            // 同一請求グループ内のポイントを含める
            $('#confirm #familyPointAgree').prop('checked', false).change();
            // すべてのポイントを利用する
            $('#confirm #usePointOption01').prop('checked', false).change();
            $('#confirm #usePointOption02').prop('checked', false).change();
            $('#confirm .checked').removeClass('checked');

            // ------------------
            // 契約者情報
            // ------------------
            accountInfo = undefined;
            isTerminal = undefined;
        },

        displayShopLogo: function (logoFileName) {

            if (!isEmpty(logoFileName)) {
                // 代理店ロゴを表示させる
                $('#headerImgId').html(`<img class="header_style" src="https://online-shop.mb.softbank.jp/ols/form/images/smp/icon/${logoFileName}"
                onerror="this.style.display='none';">`);
            }
        },
        
        tds2Callback: function (response) {
            if (sbpsWindow != undefined) {
                sbpsWindow.close();
            }
            document.cookie = `${"JSESSIONID"}=${TDS2_APPROVE_JSESSION_ID};path=${"/aw"};` 
            if(envirment_id == 'pr'){
                document.cookie = `${"VrFd7CfwmniRGgZT4VPv+zvOa9Mb4INZftjI-tKumCumHF2MXbiQuwLCwmi4KmdzLU0_"}=${TDS2_APPROVE_PR1};path=${"/"};` 
                document.cookie = `${"VrFd7CfwmniRGgdX7VLv+zvOa98N4INZftjI-tKumCumHF2MXrGOogXUwnTVKQF7JQ__"}=${TDS2_APPROVE_PR2};path=${"/"};`	
            } else {
                document.cookie = `${"VrFd7CfwmniRGgZT4VPv+zvOa9Mb4INZftjI-tKumCumHF2MXbSJogDb3mu4KmdzLU0_"}=${TDS2_APPROVE_ST};path=${"/"};` 
            }

            if (response.res_result == 'OK') {

                // GAサイト分析
                var pageName = "aw_sbpsSuccess_" + TDS2_ORDER_ID;
                var gaString = getEnviromentInfo(gaList);
                if (gaString) {
                    window.dataLayer.push({'pageUrl': '/' + pageName + '.html', 'event': 'olsEcFlow'});
                }

                applyRegistInfo['res_tracking_id'] = response.res_tracking_id;
            
            // 伝票登録API呼出
            $.ajax({
                timeout: 1000 * 30,
                async: false,
                cache: false,
                type: 'POST',
                dataType: 'json',
                url: '/aw/api/v1/orders',
                contentType: 'application/json',
                data: JSON.stringify(applyRegistInfo),
                success: function (data) {
                    Complete.displayEmail();
                    Complete.displayApplicationNumber(data.accept_number);
                    Complete.setEntryInfoComfirmUrl();
                    Complete.setWtrTag(data.accept_number);
                    OLS.proceed('complete');
                },
                beforeCommonErrorModalShow: function (data, textStatus, jqXHR) {
                    if (!isEmpty(jqXHR.responseJSON) &&
                        !isEmpty(jqXHR.responseJSON.error) &&
                        !isEmpty(jqXHR.responseJSON.error.code)) {
                        // 利用ポイントが不足して場合。
                        if (jqXHR.responseJSON.error.code == "AW400018") {
                            this.afterCommonErrorModalClosed = function () {
                                getPoint();
                                $('body,html').animate({
                                    scrollTop: $(".pointTitle:visible").offset().top - 150
                                }, 300);
                            };
                        }
                    }
                    // 「申し込み内容を確定する」ボタンを活性化
                    $("#go-to-complete").removeClass("disabled");
                    $("#identity-go-to-complete").removeClass("disabled");
                }
            });
          } else {
              // GAサイト分析
              var pageName = "aw_sbpsError_" + TDS2_ORDER_ID + "_" + response.res_err_code;
              var gaString = getEnviromentInfo(gaList);
              if (gaString) {
                  window.dataLayer.push({'pageUrl': '/' + pageName + '.html', 'event': 'olsEcFlow'});
              }
              
              // SBPSエラーハンドリング
                switch (response.res_err_code) {
                  case '7202':
                  case '7203':
                  case '7204':
                  case '7205':
                  case '7212':
                  case '7230':
                  case '7242':
                  case '7244':
                  case '7245':
                  case '7246':
                  case '7254':
                  case '7255':
                  case '7265':
                  case '7283':
                  case '7222':
                  case '7702':
                  case '7703':
                  case '7704':
                  case '7705':
                  case '7706':
                  case '7716':
                  case '7717':
                    Utils.openModal(getMessage("popup_three_d_error_code","popup"),getMessage("popup_button_close","popup"));
                    $("#go-to-complete").removeClass("disabled");
                    $("#identity-go-to-complete").removeClass("disabled");
                    break
                  case '7256':
                  case '7260':
                  case '7261':
                  case '7267':
                  case '7268':
                  case '7269':
                  case '7270':
                  case '7271':
                  case '7272':
                  case '7273':
                  case '7274':
                  case '7275':
                  case '7276':
                  case '7277':
                  case '7278':
                  case '7280':
                  case '7281':
                  case '7284':
                  case '7292':
                  case '7294':
                  case '7295':
                  case '7297':
                  case '7298':
                  case '7299':
                  case '7103':
                  case '7115':
                  case '7220':
                  case '7221':
                  case '7800':
                  case '7801':
                  case '7802':
                  case '7904':
                  case '7905':
                    Utils.openModal(getMessage("popup_three_d_error_code2","popup"),getMessage("popup_button_close","popup"));
                    $("#go-to-complete").removeClass("disabled");
                    $("#identity-go-to-complete").removeClass("disabled");
                    break

                  default:
                    // 上記以外の場合、ただ混み画面に遷移
                    location.replace(ERROR_URL + '?errorMessage=' +
                            encodeURIComponent(getMessage("message_error_sbps", "errPage")));
                }
          }
        }
    };

    // パラメータの解析
    var r = '[?&]([^=]+)=([^#&]*)';
    var p = location.search.match(new RegExp(r, 'g'));
    var h = {};
    $.each(p || [], function (i, v) {
        var _p = v.match(new RegExp(r));
        h[_p[1]] = _p[2];
    });

    // UA判定、classを設定する
    UA = getUA();
    if (UA.isIE) $('html').addClass('thisIE');
    if (UA.isChrome) $('html').addClass('thisChrome');
    if (UA.isWindows) $('html').addClass('thisWindows');

    // UAチェックファンクション呼び出し
    userAgentChk();

    // 認証URL
    APPROVEURL_URL = getEnviromentInfo(approveurlList);

    // olsInitString情報
    var olsInitString = getEnviromentInfo(olsInitStringList);
    if (olsInitString) {
        setTimeout(olsInitString, 50);
    }
});

$(document).ready(function () {
    // チェックボックスのCSS設定
    $("input[type=checkbox]").on("click", function () {
        $(this).parent().toggleClass("checked");
    });

   // 職業セレクトボックスのチェンジイベント。
    $(document).on('change', '#jobInstallmentCd, #sbJobCd', function(event) {
        viewContractorOffice($(this));
    });

    $(document).on('click', '#tradeInRecoveryKitGuidance .j_toggleBtn', function() {
        // 機種の回収・下取り欄
        if ($('#tradeInRecoveryKitGuidance .j_toggleBtn').hasClass('active')){
            // アコーディオンを閉じる
            $('#tradeInRecoveryKitGuidance .j_toggleBtn').removeClass('active');
            $('#tradeInRecoveryKitGuidance .j_toggleDetail').slideUp(200).removeClass('active');
        } else {
            // アコーディオンを開く
            $('#tradeInRecoveryKitGuidance .j_toggleBtn').addClass('active');
            $('#tradeInRecoveryKitGuidance .j_toggleDetail').slideDown(200).addClass('active');
        }
        // ボタンの文言の切り替え
        if ($('#tradeInRecoveryKitGuidanceBtn').text() === '詳しくみる') {
            $('#tradeInRecoveryKitGuidanceBtn').text('　閉じる　');
        } else {
            $('#tradeInRecoveryKitGuidanceBtn').text('詳しくみる');
        }
    });

    // 規約同意のscroll
    if (UA.isSp || UA.isTab) {
        $(".scrollArea").css("overflow-y", "auto");
    } else {
        $(".scrollArea").css("overflow-y", "hidden");
    }

    // 確認画面のbind事件
    confirmScreenBinds();
});

$(function () {
    //ReserveLogin
    $('#reserveLogin input').focusout(function () {
        validateItem(ReserveLogin, $(this));
    }).bind('keyup change', function () {
        validateItem(ReserveLogin, $(this));
        $('#reserveLogin div.btnArea a.btn.button-next').toggleClass('disabled', preventProceed(ReserveLogin));
    })

    // 移動機物品販売の場合、予約番号欄を追加する
    // 1.初期表示 2.認証から戻る場合
    if ((Utils.getUrlParameter()["seriesDiv"] == "aw" || Utils.getUrlParameter()["seriesDiv"] == "wd")
        || (Utils.getUrlParameter()["seriesDiv"] == undefined
                && (OLS.getSessionStorage("isNewAw") == "true" || OLS.getSessionStorage("isWd") == "true"))) {
        // Contractor ReserveLogin
        $('#contractorReserveNo').focusout(function () {
            validateItem(ContractorReserveLogin, $(this));
        }).bind('keyup change', function () {
            validateItem(ContractorReserveLogin, $(this));
            $('#go-to-mySoftbank-login').toggleClass('disabled', preventProceed(ContractorReserveLogin));
        })
    } else {
        // 旧AWの場合、予約番号を追加不要
        $("#contractorReserveNoArea").remove();
    }

    // NonSbCustomerInfoEntry
    $('#nonSbCustomerInfoEntry input').blur(function () {
        validateItem(NonSbCustomerInfoEntry, $(this));
    }).bind('keyup change', function () {
        validateItem(NonSbCustomerInfoEntry, $(this));
        if(lastHlrPasswordShowFlg != undefined && lastHlrPasswordShowFlg != thisHlrPasswordShowFlg){
            if(!lastHlrPasswordShowFlg && thisHlrPasswordShowFlg){
                NonSbCustomerInfoEntry.validated.hlrPassword.valid = false;
            }
        }
        $('#btn-to-delivery-pay').toggleClass('disabled', preventProceed(NonSbCustomerInfoEntry));
        $('#btn-nonsbcus-to-agreement').toggleClass('disabled', preventProceed(NonSbCustomerInfoEntry));
    });

    $('#nonSbCustomerInfoEntry select').blur(function () {
        validateItem(NonSbCustomerInfoEntry, $(this));
    }).bind('keyup change', function () {
        validateItem(NonSbCustomerInfoEntry, $(this));
        if(lastNationalShowFlg != undefined && lastNationalShowFlg != thisNationalShowFlg){
            if(!lastNationalShowFlg && thisNationalShowFlg){
                NonSbCustomerInfoEntry.validated.nationalityCd.valid = false;
            }
        }
        $('#btn-to-delivery-pay').toggleClass('disabled', preventProceed(NonSbCustomerInfoEntry));
        $('#btn-nonsbcus-to-agreement').toggleClass('disabled', preventProceed(NonSbCustomerInfoEntry));
    });

    $('#nonSbCustomerInfoEntry div.contractorAddressArea input[type=text]').focus(function () {
        validateItem(NonSbCustomerInfoEntry, $('#nonSbCustomerInfoEntry #contractorAddressArea'));
    });

    //Zipcode handler
    $('#nonSbCustomerInfoEntry #contractorZipCd').change(Utils.zipcodeKeydownHandler);
    $('#nonSbCustomerInfoEntry #contractorZipCd').formatter({
        'pattern' : '{{999}}-{{9999}}'
    });

    $('#sbCustomerInfoEntry input, #sbCustomerInfoEntry select').focusout(function () {
        validateItem(SbCustomerInfoEntry, $(this));
    }).bind("keyup change", function () {
        validateItem(SbCustomerInfoEntry, $(this));
        $('#sbCustomerInfoEntry .btnArea .btn').toggleClass('disabled', preventProceed(SbCustomerInfoEntry));
    });
});

$(function () {
    $('#delivery select, #delivery div.sendToAddressArea input[type=text], #delivery input[type=tel], #selectPay select, #selectPay input, #otherAddress').focusout(function (e) {
        validateItem(Delivery, $(this));
    }).bind('keyup change', function () {
        validateItem(Delivery, $(this));
        $('#delivery-form-submit-btn').toggleClass('disabled', preventProceed(Delivery));
    });

    $('#delivery div.sendToAddressArea input[type=text]').focus(function () {
        validateItem(Delivery, $(this));
    })

    //Zipcode handler
    $('#delivery #sendToZipCd').change(Utils.zipcodeKeydownHandler);
    $('#delivery #sendToZipCd').formatter({
        'pattern' : '{{999}}-{{9999}}'
    });
});

$(function () {
    //Pay
    $('#pay input').blur(function () {
        validateItem(Pay, $(this));
    }).bind('keyup change', function () {
        validateItem(Pay, $(this));
        $('#btn-pay-to-agreement').toggleClass('disabled', preventProceed(Pay));
    });

    $('#pay select').blur(function () {
        validateItem(Pay, $(this));
    }).bind('keyup change', function () {
        validateItem(Pay, $(this));
        $('#btn-pay-to-agreement').toggleClass('disabled', preventProceed(Pay));
    });

});

// 性別を選択する時のアニメーション
$(function () {
    $('.radioBox').click(function (e) {
        if($(this).prop('id') != 'payStyleCreditCard'){
            $(this).siblings('.radioBox').removeClass('checked');
            $(this).addClass('checked');
        }
    });

    // 「別に住所の配送を希望する」OFF⇒ON
    $(document).on('click', 'input:checked#otherAddress', function(){
        var clickTimes = parseInt($('#otherAddress').attr('data-clickTimes'), 10);

        $('#deliveryToAddressInputArea').show();
        // バリデーションチェック
        //$('#delivery select, #delivery div.sendToAddressArea input[type=text], #delivery input[type=tel], #selectPay select, #selectPay input, #otherAddress').each(function(){
        $('#deliveryToAddressInputArea select, #deliveryToAddressInputArea input, #otherAddress').each(function(){
            validateItem(Delivery, $(this), true);
        });
        $('#delivery-form-submit-btn').toggleClass('disabled', preventProceed(Delivery));

        clickTimes = clickTimes + 1;
        $('#otherAddress').attr('data-clickTimes', clickTimes.toString(10));

        // 初回クリック以外バリデーションチェックを行う
        if (clickTimes > 1) {
            //$('#delivery select, #delivery div.sendToAddressArea:not(:last-child) input[type=text], #delivery input[type=tel]').change();
            $('#deliveryToAddressInputArea select, #deliveryToAddressInputArea input, #otherAddress').change();
        }
    });
    // 「別に住所の配送を希望する」ON⇒OFF
    $(document).on('click', 'input:not(:checked)#otherAddress', function(){
        $("#otherAddress").prop("checked", false);
        $("#otherAddress").parent().parent().removeClass("checked");
        $('#deliveryToAddressInputArea').hide();
        // バリデーションチェック
        //$('#delivery select, #delivery div.sendToAddressArea input[type=text], #delivery input[type=tel], #selectPay select, #selectPay input, #otherAddress').each(function(){
        $('#deliveryToAddressInputArea select, #deliveryToAddressInputArea input, #otherAddress').each(function(){
            validateItem(Delivery, $(this), true);
        });
        // ボタン制御
        $('#delivery-form-submit-btn').toggleClass('disabled', preventProceed(Delivery));
    });

    $('label.btnSelect input[type=checkbox]').click(function (e) {
        $(this).closest('label').toggleClass('checked');
    });
    $('#agreement form.formReset .btnArea label.btnSelect input[type=checkbox]#allAgree').click(function (e) {
        if ($(this).is(':checked')) {
            $('#agreement #link .btnArea > a').removeClass('disabled');
        } else {
            $('#agreement #link .btnArea > a').addClass('disabled');
        }
    });

    $('#sbCustomerInfoEntry input[type=email], #sbCustomerInfoEntry input[type=tel], #sbCustomerInfoEntry input[type=text]').focusout(function () {
        validateItem(SbCustomerInfoEntry, $(this));
    }).bind("keyup change", function () {
        validateItem(SbCustomerInfoEntry, $(this));
        if(lastSbHlrPasswordShowFlg != undefined && lastSbHlrPasswordShowFlg != thisSbHlrPasswordShowFlg){
            if(!lastSbHlrPasswordShowFlg && thisSbHlrPasswordShowFlg){
                SbCustomerInfoEntry.validated.sbhlrPassword.valid = false;
            }
        }
        $('#sbCustomerInfoEntry .btnArea .btn').toggleClass('disabled', preventProceed(SbCustomerInfoEntry));
    })
});

//TOPに戻る矢印のアニメーション
$(function () {
    var topBtn = $('#pagetop');
    topBtn.hide().click(goToTop);
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
});

function goToTop(duration) {
    $('body,html').animate({
        scrollTop: 0
    }, duration || 0);
    return false;
};

// 金額総額文言表示制御
function totalPriceTxtDisplayControl (){
    if (totalPriceDispCtlFlg) {
        $('.totalPriceHideCtl').hide();
        $('.totalPriceShowClt').show();
    } else {
        $('.totalPriceHideCtl').show();
        $('.totalPriceShowClt').hide();
    }
};

// 職業の表示制御。
function viewContactJob() {
    var tokusuruSupportJudgeKbn = '';
    var tokusuruSupportVal = '';
    if ($('input[name="privilegeUseSelect"]:checked').val()) {
        tokusuruSupportJudgeKbn = $('input[name="privilegeUseSelect"]:checked').val().split(',')[0];
        tokusuruSupportVal = $('input[name="privilegeUseSelect"]:checked').val().split(',')[1];
    }
    // 機種の回収・下取り欄の特典利用欄を選択している場合
    if ($('#collectionTradeInPrivilegeUseSelect').css('display') === 'block'
        && ((tokusuruSupportJudgeKbn === TOKUSURU_SUPPORT_JUDGE_KBN.newTokusuruSupport
            && (tokusuruSupportVal === TOKUSURU_SUPPORT_USE_CODE_LIST.TokusuruSupport_UseOfUpgradeInOneYearCampaign
                    || tokusuruSupportVal === TOKUSURU_SUPPORT_USE_CODE_LIST.TokusuruSupport_Use))
            || isTradeInProgram(tokusuruSupportJudgeKbn))) {
        // 新トクするサポート選択時
        // 下取りプログラム選択時
        return true;
    }
    return false;
}

//入力画面各情報のvalid状態初期化
function resetVaildValue (keyId) {
    // 未入力かつエラー状態無しの場合
    if ($('#' + keyId + '.error').length == 0) {
        // 未入力かつエラー状態無しの場合
        if (isSb) {
            SbCustomerInfoEntry.validated[keyId].valid = '';
        } else {
            NonSbCustomerInfoEntry.validated[keyId].valid = '';
        }
    } else {
        // エラー状態有りの場合
        if (isSb) {
            SbCustomerInfoEntry.validated[keyId].valid = false;
        } else {
            NonSbCustomerInfoEntry.validated[keyId].valid = false;
        }
    }
}

//勤務先情報入力欄の表示制御。
function viewContractorOffice(item) {
    var val = item.val();
    var id = item.attr('id');
    var contractorOtherJob = '';

    // 勤務先項目
    // 職業名(補足)
    if (isSb) {
        contractorOtherJob = $('div.sbOtherjob');
    } else {
        contractorOtherJob = $('div.otherjob');
    }

    if (isSb) {
        var contractorOffice = $('div.sbContractorOffice');
        var contractorOfficeInput = $('div.sbContractorOffice input');
        var contractorOfficeSelect = $('div.sbContractorOffice select');
    } else {
        var contractorOffice = $('div.contractorOffice');
        var contractorOfficeInput = $('div.contractorOffice input');
        var contractorOfficeSelect = $('div.contractorOffice select');
    }
    if (val !== '') {
        // 文字色彩の変更
        $('#' + id + '').removeClass("placeholder");
        // 選択してください以外を選択した場合、勤務先情報入力欄を表示にする。
        contractorOffice.show();
        // 職業は「その他」の場合、職業名入力欄表示
        if (val === JOB_CD_LIST.other) {
            contractorOtherJob.show();
            if (isSb) {
                // 勤務先情報入力欄のストライプの設定
                setListStripe('div.sbContractorOffice', BG_COLOR.white, BG_COLOR.gray);
            } else {
                if (thisNationalShowFlg) {
                    // 勤務先情報入力欄のストライプの設定
                    setListStripe('div.contractorOfficedetail', BG_COLOR.gray, BG_COLOR.white);
                } else if (thisJobOnlyShowFlg) {
                    // 勤務先情報入力欄のストライプの設定
                    setListStripe('div.contractorOfficedetail', BG_COLOR.white, BG_COLOR.gray);
                }
            }
        } else {
            contractorOtherJob.hide();
            if (isSb) {
                // 勤務先情報入力欄のストライプの設定
                setListStripe('div.sbContractorOffice', BG_COLOR.gray, BG_COLOR.white);
            } else {
                if (thisNationalShowFlg) {
                    // 勤務先情報入力欄のストライプの設定
                    setListStripe('div.contractorOfficedetail', BG_COLOR.gray, BG_COLOR.white);
                } else if (thisJobOnlyShowFlg) {
                    // 勤務先情報入力欄のストライプの設定
                    setListStripe('div.contractorOfficedetail', BG_COLOR.white, BG_COLOR.gray);
                }
            }
        }
        
        // 勤務先名、勤務先名フリガナ、勤務先電話番号は必須項目に設定
        if (val === JOB_CD_LIST.employee
                || val === JOB_CD_LIST.publicOfficials
                || val === JOB_CD_LIST.selfEmployed
                || val === JOB_CD_LIST.employeeSelfEmployee
                || val === JOB_CD_LIST.twoIncomes
                || val === JOB_CD_LIST.other) {
            contractorOffice.find('.requiredText').text('※必須');
            contractorOfficeInput.attr('required', '');
            contractorOfficeSelect.attr('required', '');
        } else {
           // 職業が上記以外の場合は
           // 勤務先名、勤務先名フリガナ、勤務先電話番号は必須項目を解除 
            contractorOffice.find('.requiredText').text('');
            contractorOfficeInput.removeAttr('required');
            contractorOfficeSelect.removeAttr('required');
        }
    } else {
        // 
        $('#' + id + '').removeClass("placeholder");
        // 上記以外（選択してください）を選択した場合、勤務先情報入力欄を非表示にする。
        contractorOffice.hide();
        contractorOtherJob.hide();
    }
}

var agreeCtl = {
        agreeLoad: function () {
            $(".agreeAllBRDesign").remove();
            $('.agree-info .stripeItem').each(function() {
                if ($(this).css('display') !== 'none') {
                    $(this).css('background-color', '#ececec');
                    $(this).after('<br class="agreeAllBRDesign">');
                }
            });
        }
};

var clickHandlers = {
    // 非SB顧客入力画面で「住所を検索する」を押した時のイベント
    addSearchFromZip: function () {
        NonSbCustomerInfoEntry.displayContractorAddressArea($('#contractorZipCd'));
    },

    // 配送画面で「住所を検索する」を押した時のイベント
    sendToAddSearchFromZip: function () {
        Delivery.displayContractorAddressArea($('#delivery #sendToZipCd'));
    },

    contractBtn_agreement: function (e) {
        $(e.target).parent().find('a').toggleClass('active');
        $(e.target).parent().siblings('.j_toggleDetail').toggle();
    },

    pageOpenCloseToggle: function (e) {
        $(e.target).parent().parent().parent().find('.pageOpen').toggle();
        $(e.target).parent().parent().parent().find('.pageClose').toggle();
    },

    closeModal: function () {
        $('#j_modalBoxClose').click();
    },
    // 本人確認書類認証番号別の画像を表示する
    kaptchaImgChange: function () {
        $('#kaptchaImg').attr('src', '/aw/Kaptcha.jpg?v=' + new Date().getTime());
        $('#kaptchaCode').val('');
    }
};
